import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Chart } from 'chart.js/auto';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { DeviceService } from 'src/app/services/device.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { addDays, compareAsc, parse, format } from 'date-fns';
import * as ExcelJS from 'exceljs';
import { Meta } from '@angular/platform-browser';
import { NumberService } from 'src/app/services/number.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UserDataService } from 'src/app/services/user-data.service';
import { ToastrService } from 'ngx-toastr';
import zoomPlugin from 'chartjs-plugin-zoom';
//import * as XLSX from 'xlsx';
interface Establecimiento{
  value: number;
  name: string;
}
interface Paises{
  name: string;
}
interface Comunidades{
  name: string;
  pais: string;
}
interface Provincias{ 
  name: string;
  comunidad: string;
  pais: string;
}
interface Localidades{
  id: number;
  name: string;
  codigoPostal: string;
  provincia: string;
  comunidad: string;
  pais: string;
}
interface Cervezas{
  value: number;
  name: string;
  consumoTotal?: number;
}
interface RankingEstablecimientos{
  name: string;
  consumoTotalEstrella: number;
  consumoTotal1906: number;
  consumoTotalAlouminha: number;
  consumoTotal: number;
}
interface RankingEstablecimientos1 {
  name: string;
  consumosTotales: { id: number, type: string; consumo: number }[];
  consumoTotal: number;
}
interface RankingProvincias{
  name: string;
  nEstablecimientos: number;
  consumosTotales: { type: string; consumo: number}[];
  consumoMedioEstablecimiento: number;
  consumoTotal: number;
}
interface ConsumoPorHora {
  [hora: number]: {
    consumoEstrellaEspecial: number;
    consumoEstrella1906: number;
    consumoAlouminha: number;
  };
}
interface ConsumoPorDia {
  [fecha: string]: {
    consumoEstrellaEspecial: number;
    consumoEstrella1906: number;
    consumoAlouminha: number;
  };
}
interface Filtros {
  id: number,
  name: string,
  filters: string,
  created_at: string,
  updated_at: string,
  user_id: number,
}
@Component({
  selector: 'app-estadisticas-consumo',
  templateUrl: './estadisticas-consumo.component.html',
  styleUrls: ['./estadisticas-consumo.component.css']
})
export class EstadisticasConsumoComponent implements OnInit{

  //FECHAS
    fechaActual: Date = new Date();
    dia: number = this.fechaActual.getDate(); 
    mes: number = this.fechaActual.getMonth(); 
    anio: number = this.fechaActual.getFullYear(); 
    mes1 = this.mes + 1;
    fechaActualString: string = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${this.dia.toString().padStart(2, '0')}`;
    fechaMinima = new Date(this.anio, this.mes, this.dia-1);

    selectedDateGlobal: FormGroup;
    startGlobal: string = "";
    endGlobal: string = "";

    selectedDateTopEstablecimientos = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
    startTopEstablecimientos: string = "";
    endTopEstablecimientos: string = "";

    selectedDateCervezasSemanal = new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    });
    startTopCervezasSemanal: string = "";
    endTopCervezasSemanal: string = "";

    selectedDateMediaHoras = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
    startTopMediaHoras: string = "";
    endTopMediaHoras: string = "";

    selectedDateDiario = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
    startTopDiario: string = "";
    endTopDiario: string = "";

    selectedDateMediaEstProvincia = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
    startTopMediaEstProvincia: string = "";
    endTopMediaEstProvincia: string = "";

  devicesReferences: string = ""; //Referencias de los dispositivos seleccionados
  opcionSeleccionada: string = "porTotal";
  selectAllEstablecimientos: boolean = false;
  selectAllLocalidades: boolean = false;
  selectAllProvincias: boolean = false;
  selectAllComunidades: boolean = false;
  selectAllPaises: boolean = false;
  selectAllCervezas: boolean = false;
  ubicacionSeleccionada: string = "";

  //TABLA RESTULADOS
  displayedColumns: string[] = [];
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('TABLE') table!: ElementRef;
  consumoTotal: number = 0;
  numeroFilas: number = 0;
  pageSizeOptions: number[] = [1, this.numeroFilas];
  mostrarTabla: boolean = false;
  mostrarTabla1: boolean = false;
  dataSource :any;
  establecimiento: string = "";
  consumoPorHoras: number = 0;
  consumoPorDias: number = 1;
  consumoPorSemana: number = 2;
  consumoPorMes: number = 3;
  cargarDatos: boolean | undefined = false;

  //GRAFICAS CARGADAS
  rakingEstablecimientosCambiadaCargarda: boolean = false;
  semanalEspanaCambiadaCargada: boolean = false;
  mediaHorasCambiadaCargada: boolean = false;
  diarioCambiadaCargada: boolean = false;
  provinciasCambiadaCargada: boolean = false;

  //NO HAY DATOS
  rankingEstablecimientosDatos: boolean = true;
  semanalDatos: boolean = true;
  mediaHorasDatos: boolean = true;
  diarioDatos: boolean = true;
  provinciasDatos: boolean = true;
  
  //TEXTO CON FILTROS
  intervalosFecha: string = "";
  primerNombreEstablecimiento: string = "";
  todosIguales: boolean = false;
  sinDatos: boolean = false;
  textoResumen: string | undefined

  //UBICACION
  paises: Paises[] = [];
  selectedPaises: string [] = [];

  comunidades: Comunidades[] = [];
  comunidadesOriginal: Comunidades[] = [];
  selectedComunidades: string [] = [];

  provincias: Provincias[] = [];
  provinciasOriginal: Provincias[] = [];
  selectedProvincias: string [] = [];

  localidades: Localidades[] = [];
  localidadesOriginal: Localidades[] = [];
  selectedLocalidades: number [] = [];

  //ESTABLECIMIENTOS
  establecimientos: Establecimiento[] = [];
  selectedEstablecimiento: number [] = [];
  establecimientosCopia: Establecimiento[] = [];
  listaEstablecimientos: any [] = [];

  //CERVEZAS
  cervezas: Cervezas[] = []
  cervezasEstadisticas: Cervezas[] = []
  cervezasHard: Cervezas[] = []
  cervezasControl: FormControl = new FormControl();
  cervezasControlHard: FormControl = new FormControl();
  selectedCervezas: number [] = [];
  cervezasDisponibles: number[] = [];
  cervDisponibles: number[] = [];
  cervezasIguales: boolean = false;

  //RANKINGStopRankingCervezas
  establecimientosId: any [] = [];
  rankingData: RankingEstablecimientos[] = [];
  topRankingData: RankingEstablecimientos[] = [];
  consumoTotalesTotalesPorCerveza: { type: string; consumo: number }[] = [];
  rankingData1: RankingEstablecimientos1[] = [];
  topRankingData1: RankingEstablecimientos1[] = [];
  rankingDataProvincias: RankingProvincias[] = [];
  topRankingDataProvincias: RankingProvincias[] = [];
  rankingDataSemanal: any[] = [];
  rankingDataDiario: any[] = [];
  rankingDataHoras: any[] = [];
  rankingCervezasData: any [] = [];
  rankingConsumoPorHora: any = [];
  topRankingCervezas: any [] = [];
  charts: Chart[] = [];
  consumoEstrellaHoras: number [] = [];
  consumo1906Horas: number [] = [];
  consumoPorHora: ConsumoPorHora = {};
  consumoDiarioSemana: ConsumoPorDia = {};
  consumoDiaroAny: any [] = [];
  establecimientosPorProvincia: any [] = [];
  consumosPorProvincia: any [] = []
  consumoMedioTotalPorProvincia: any [] = [];
  consumoProvinciaTop: any [] = [];
  rankingInfoConseguida: boolean = false;
  rankingCervezasInfoConseguida: boolean = false;
  mediaCervezasConseguida: boolean = false;
  diarioCervezasConseguida: boolean = false;
  provinciasConseguido: boolean = false;
  chartRanking: any;
  chartMediasHoras: any;
  chartRankingCervezas: any;
  chartDiarioSemana: any;
  chartProvinciasEstablecimientos: any;
  stringFechaConsumoDiarioEspaña: string = "Fecha (Día/Mes/Año)";
  stringFechaConsumoSemanalCervezas: string = "Semanas (año/semana)";
  cervezasSeleccionadas: any;

  //DATOS
  establecimientosData: any = []; //Información de los clientes
  errorMessage: string = "";
  tiempoEsperaRecarga: number = 60000;
  userData: any = [];

  //LISTA DE FILTROS
  nombreFiltro: string = "";
  myControl = new FormControl<string | Filtros>('');
  tablaDeFiltros: Filtros [] = [];
  filteredOptions!: Observable<Filtros[]>;

  //TAB
  estadisticasActivas: boolean = true;
  graficasActivas: boolean = false;

  //ALERTAS
  waitAfterSave: boolean = false;

  //CONSUMO DIA ACTUAL
  consumoDiaActual: any = [];

  //COLORES
  backgroundColors: any = ["#9AD0F5", "#FFB1C1", "#FFCF9F", "#FFE6AA", "#A5DFDF", "#CCB2FF", "#E4E5E7"];
  //Convertirlos a ARGBA para poder ponerles la opacidad que queramos
  convertirHexARGBA = (hexColor: string, opacidad: number): string => {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacidad})`;
  };
  backgroundColorsOpacos = this.backgroundColors.map((color:any) => this.convertirHexARGBA(color, 1));
  borderColor: any = ["#36A2EB","#FF6384","#FF9F40","#FFCD56","#4BC0C0","#9966FF","#C9CBCF"];

  // DATEPICKER FILTER
  myFilter = (d: Date | null): boolean => {
    const selectedStart = this.selectedDateCervezasSemanal.get('start')?.value;
    const selectedEnd = this.selectedDateCervezasSemanal.get('end')?.value;
  
    // Si start está definido pero end aún no se ha seleccionado, deshabilitar las fechas
    if (selectedStart && !selectedEnd) {
      const startDate = new Date(selectedStart);
      const endDate = new Date(selectedStart); // Usamos la fecha de start para calcular los 30 días posteriores
      endDate.setDate(startDate.getDate() + 30);
  
      // Deshabilitar si la fecha está dentro de los 30 días después del inicio seleccionado
      return !(d && d >= startDate && d <= endDate);
    }
  
    // Permitir todas las fechas en otros casos
    return true;
  };
  
  private clientsSubscription: Subscription | undefined;
  private usersSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private resultadoSubscription: Subscription | undefined;
  private rankingSubscription: Subscription | undefined;
  private rankingCervezasSubscription: Subscription | undefined;
  private mediaHorasSubscription: Subscription | undefined;
  private diasCervezaSubscription: Subscription | undefined;
  private tablaBusquedaSubscription: Subscription | undefined;
  private crearBusquedaSubscription: Subscription | undefined;
  private eliminarBusquedaSubscription: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;

  constructor(private dateAdapter: DateAdapter<Date>, private error429: Error429Service, private deviceService: DeviceService,
     private formBuilder: FormBuilder, private meta: Meta, private numberService: NumberService, private userDataService: UserDataService,
     private toastr: ToastrService, private fb: FormBuilder){
      this.userData = this.userDataService.getUserData();

      // Hacer que la fecha máxima sea el dia anterior al actual
      const fechaMinima = new Date(this.anio, this.mes, this.dia-1);
      this.selectedDateGlobal = this.fb.group({
        start: [fechaMinima, Validators.required],
        end: [fechaMinima, Validators.required],
      });
      this.fechaActual.setDate(this.fechaActual.getDate() - 1);
      /*const viewport = this.meta.getTag('name = viewport');
      const keywords = this.meta.getTag('name = keywords');
      const STS = this.meta.getTag('name = Strict-Transport-Security');
      const XContentTypeOptions = this.meta.getTag('name = X-Content-Type-Options');
      const XFrameOptions = this.meta.getTag('name = X-Frame-Options');
      const name1 = this.meta.getTag('name = Referrer-Policy');
      const name2 = this.meta.getTag('name = Permissions-Policy');
      const name3 = this.meta.getTag('name = Expect-CT');
      const name4 = this.meta.getTag('name = Cross-Origin-Embedder-Policy');
      const name5 = this.meta.getTag('name = Cross-Origin-Resource-Policy');
      const name6 = this.meta.getTag('name = Cross-Origin-Opener-Policy');
      if (viewport) console.log(viewport.content);
      if (keywords) console.log(keywords.content);
      if (STS) console.log(STS.content);
      if (XContentTypeOptions) console.log(XContentTypeOptions.content);
      if (XFrameOptions) console.log(XFrameOptions.content);
      if (name1) console.log(name1.content);
      if (name2) console.log(name2.content);
      if (name3) console.log(name3.content);
      if (name4) console.log(name4.content);
      if (name5) console.log(name5.content);
      if (name6) console.log(name6.content);*/
  }

  ngOnInit(): void {
    //Conseguir datos de los establecimientos
    this.clientsSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          if(resp[i].status == 1){
            this.establecimientosData.push(resp[i]);
            this.establecimientosId.push(resp[i].id);
            //console.log(resp[i].est_beertypes);
            this.establecimientos.push({
              value: resp[i].id,
              name: resp[i].est_name
            });
            this.establecimientosCopia.push({
              value: resp[i].id,
              name: resp[i].est_name
            });
            this.ordenarEstablecimientos();
            this.ordenarEstablecimientosCopia();
            //Paises disponibles
            if(resp[i].localidad !== null &&  resp[i].localidad.country !== null){
              this.paises.push({
                name: resp[i].localidad.country
              });
            }
            //Comunidades disponibles
            if(resp[i].localidad !== null &&  resp[i].localidad.administrative_area_level_1 !== null){
              this.comunidades.push({
                name: resp[i].localidad.administrative_area_level_1,
                pais: resp[i].localidad.country
              });
            }
            //Provincias disponibles
            if(resp[i].localidad !== null &&  resp[i].localidad.administrative_area_level_2 !== null){
              this.provincias.push({
                name: resp[i].localidad.administrative_area_level_2,
                comunidad: resp[i].localidad.administrative_area_level_1,
                pais: resp[i].localidad.country
              });
            }
            //Localidades disponibles
            /*if(resp[i].localidad !== null &&  resp[i].localidad.name !== null){
              console.log(resp[i].localidad.name);
            }*/
            if(resp[i].postal_code){
              if(resp[i].localidad !== null &&  resp[i].localidad.name !== null){
                this.localidades.push({
                  id: resp[i].localidad_id,
                  name: resp[i].localidad.name,
                  codigoPostal: resp[i].postal_code.code,
                  provincia: resp[i].localidad.administrative_area_level_2,
                  comunidad: resp[i].localidad.administrative_area_level_1,
                  pais: resp[i].localidad.country
                });
              }
            } else {
              if(resp[i].localidad !== null &&  resp[i].localidad.name !== null){
                this.localidades.push({
                  id: resp[i].localidad_id,
                  name: resp[i].localidad.name,
                  codigoPostal: "",
                  provincia: resp[i].localidad.administrative_area_level_2,
                  comunidad: resp[i].localidad.administrative_area_level_1,
                  pais: resp[i].localidad.country
                });
              }
            }
            //Cervezas disponibles
              if(resp[i].est_beertypes !== null) {
                this.cervezasDisponibles.push(resp[i].est_beertypes);
              }
          }
        }
        //CONSEGUIR LAS REFERENCIAS DE LOS DISPOSITIVOS PARA LA LLAMADA DE HISTORICOS RAW
        let devicesReferencesLista: any = [];
        for (let i = 0; i < this.establecimientosData.length; i++) {
          const references: string[] = this.establecimientosData[i].devices.map((device: { dev_reference: string }) => device.dev_reference);
          devicesReferencesLista = devicesReferencesLista.concat(references);
        }
        this.devicesReferences = devicesReferencesLista.join('-');
        //ELIMINAR DUPLICADOS
        this.paises = this.eliminarDuplicadosPaises(this.paises);
        this.comunidades = this.eliminarDuplicadosComunidades(this.comunidades);
        this.provincias = this.eliminarDuplicadosProvincias(this.provincias);
        this.localidades = this.eliminarDuplicadosLocalidades(this.localidades);
        this.localidadesOriginal = this.localidades;
        this.provinciasOriginal = this.provincias;
        this.comunidadesOriginal = this.comunidades;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{

        //CERVEZAS

        this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
          next:resp =>{
            /*this.cervezas = [
              { value: 0, name: 'Consumo Total' },
              ...resp.map((item: any) => ({ value: item.id, name: item.name }))
            ];*/
            //Consumo total que aparece en el top 10 establecimientos
            this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
            //Tipos de cerveza que aparecen en las estadísticas
            this.cervezasEstadisticas = resp.map((item: any) => ({ value: item.id, name: item.name }));
          },error: err => {
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: () => {}
        });

        //RANKING ESTABLECIMIENTOS
        const fechaActual = new Date();
        // Resta 30 días a la fecha actual
        fechaActual.setDate(fechaActual.getDate() - 30);
        const año1 = fechaActual.getFullYear();
        const mes1 = fechaActual.getMonth() + 1;
        const dia1 = fechaActual.getDate();
        // Formatea la fecha en el formato "año-mes-día"
        const fechaFormateada1 = `${año1}-${mes1 < 10 ? '0' : ''}${mes1}-${dia1 < 10 ? '0' : ''}${dia1}`;
        //const primerDiaDelMes = new Date(this.fechaActual.getFullYear(), this.fechaActual.getMonth(), 1);
        //Cambiar el input del calendario
        this.selectedDateTopEstablecimientos.setValue({start: fechaFormateada1, end: this.convertirFecha(this.fechaActual)});
        const establecimientoData = new FormData();
        establecimientoData.append('start', fechaFormateada1);
        establecimientoData.append('end', this.obtenerDiaSiguiente(this.convertirFecha(this.fechaActual)));
        establecimientoData.append('establecimientos', JSON.stringify(this.establecimientosId));
        establecimientoData.append('desglose', "total");
        this.rankingSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
          next: resp =>{
            if(resp.length == 0){
              this.rankingEstablecimientosDatos = false;
            } else {
              this.rankingEstablecimientosDatos = true;
              //Suma total de todos los establecimientos
              let consumoTotales: { id: number; type: string; consumo: number }[] = [];
              //Inicializamos los consumos totales 
              /*const listaDeCervezasConConsumo: Cervezas[] = this.cervezas.map(cerveza => ({
                ...cerveza,
                consumoTotal: 0,
              }));
              this.cervezas = listaDeCervezasConConsumo;
              this.asignarConsumo(parseFloat(key), parseFloat(beerType.consume.toFixed(2)));*/
              for(let i=0; i<resp.length; i++){
                //Reiniciamos los valores
                let consumoTotal1: number = 0;
                consumoTotales = [];
                for (const key in resp[i].beertypes) {
                  if (resp[i].beertypes.hasOwnProperty(key)) {
                    const beerType = resp[i].beertypes[key];
                    if (beerType) {
                      // Obtener el nombre de la cerveza y consumo total
                      const beerID = beerType.id;
                      const beerName = beerType.type;
                      consumoTotal1 += beerType.consume;
                      //Consumo total total
                      const consumo = parseFloat(beerType.consume.toFixed(2));
                      //console.log(beerType.consume.toFixed(2).replace('.', ','));
                
                      // Verificar si ya existe la cerveza en consumosTotales
                      const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);
                      const existingBeerIndexTotal = this.consumoTotalesTotalesPorCerveza.findIndex(item => item.type === beerName);

                      if (existingBeerIndexTotal !== -1) {
                        // Actualizar consumo si ya existe la cerveza
                        this.consumoTotalesTotalesPorCerveza[existingBeerIndexTotal].consumo += consumo;
                      } else {
                        // Agregar nueva entrada para la cerveza si no existe
                        this.consumoTotalesTotalesPorCerveza.push({ type: beerName, consumo });
                      }

                      // Poner en la gráfica las cervezas que tienen más de 0 consumo
                      if (existingBeerIndex !== -1) {
                        consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                      } else {  
                        consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                      }
                      
                    }
                  }
                }
                if(this.userData.pro_id == 4){
                  consumoTotales = consumoTotales.filter(item => item.consumo > 0);
                }
                const consumoTotalRedondeado = consumoTotal1.toFixed(2);
                const establecimientoRanking: RankingEstablecimientos1 = {
                  name: resp[i].name,
                  consumosTotales: consumoTotales, // copia para evitar referencias directas
                  consumoTotal: parseFloat(consumoTotalRedondeado),
                };
                this.rankingData1.push(establecimientoRanking);
              }
              this.rankingData1.sort((a, b) => b.consumoTotal - a.consumoTotal);
              this.topRankingData1 = this.rankingData1.slice(0, 10);
              if(this.userData.pro_id == 4){
                this.consumoTotalesTotalesPorCerveza = this.consumoTotalesTotalesPorCerveza.filter(item => item.consumo > 0);
              }
            }
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{
            this.rankingInfoConseguida = true;
            if (this.rankingInfoConseguida && this.rankingCervezasInfoConseguida && this.mediaCervezasConseguida && this.diarioCervezasConseguida && this.provinciasConseguido) {
              this.mostrarSnackbar("Las gráficas han terminado de cargarse");
            }
          }
        });    
        
        //CONSUMO PROVINCIA/ESTABLECIMIENTO
          const fechaActual2 = new Date();
          // Restarle siete días
          fechaActual2.setDate(fechaActual2.getDate() - 6);
          // Obtener el año, mes y día en formato "YYYY-MM-DD"
          const año2 = fechaActual2.getFullYear();
          const mes2 = (fechaActual2.getMonth() + 1).toString().padStart(2, '0'); // Se suma 1 porque en JavaScript los meses van de 0 a 11
          const dia2 = fechaActual2.getDate().toString().padStart(2, '0');
          // Formatear la fecha en el formato deseado
          const fechaFormateada4 = `${año2}-${mes2}-${dia2}`;
          this.selectedDateMediaEstProvincia.setValue({start: fechaFormateada4, end: this.convertirFecha(this.fechaActual)});
          const nombresProvincias = this.provincias.map(provincia => provincia.name);
          const establecimientoData4 = new FormData();
          establecimientoData4.append('start', fechaFormateada4);
          establecimientoData4.append('end', this.obtenerDiaSiguiente(this.convertirFecha(this.fechaActual)));
          establecimientoData4.append('provincias', JSON.stringify(nombresProvincias));
          establecimientoData4.append('desglose', "total");
          this.rankingCervezasSubscription = this.deviceService.getEstConsumos(establecimientoData4).subscribe({
            next: resp =>{
              if (resp.length == 0){
                this.provinciasDatos = false;
              } else {
                this.provinciasDatos = true;
                this.consumosPorProvincia = resp;
                // Filtrar los establecimientos por provincia
                for (let i = 0; i < resp.length; i++) {
                  const establecimientosProvinciaActual = this.establecimientosData.filter((establecimiento: { localidad: { administrative_area_level_2: string } }) => {
                    return resp[i].name.includes(establecimiento.localidad.administrative_area_level_2);
                  });
                  this.establecimientosPorProvincia.push({
                    provincia: resp[i].name,
                    establecimientos: establecimientosProvinciaActual,
                  });
                }
                //Suma total de todos los establecimientos
                let consumoTotales: { type: string; consumo: number}[] = [];
                for(let i=0; i<resp.length; i++){
                  //Reiniciamos los valores
                  let consumoTotal1: number = 0;
                  consumoTotales = [];
                  for (const key in resp[i].beertypes) {
                    if (resp[i].beertypes.hasOwnProperty(key)) {
                      const beerType = resp[i].beertypes[key];
                      if (beerType) {
                        // Obtener el nombre de la cerveza y consumo total
                        const beerName = beerType.type;
                        consumoTotal1 += beerType.consume;
                  
                        // Verificar si ya existe la cerveza en consumosTotales
                        const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);

                        if (existingBeerIndex !== -1) {
                          consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                        } else {  
                          consumoTotales.push({ type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                        }
                      }
                    }
                  }
                  for(let j=0; j<this.establecimientosPorProvincia.length; j++){
                    if(this.consumosPorProvincia[i].name == this.establecimientosPorProvincia[j].provincia){
                      const consumoTotalRedondeado = consumoTotal1.toFixed(2);
                      const establecimientoRanking: RankingProvincias = {
                        name: resp[i].name,
                        nEstablecimientos: this.establecimientosPorProvincia[j].establecimientos.length,
                        consumosTotales: { ...consumoTotales }, // copia para evitar referencias directas
                        consumoMedioEstablecimiento: parseFloat((parseFloat(consumoTotalRedondeado)/this.establecimientosPorProvincia[j].establecimientos.length).toFixed(2)),
                        consumoTotal: parseFloat(consumoTotalRedondeado),
                      };
                      this.rankingDataProvincias.push(establecimientoRanking);
                    }
                  }
                }
                this.rankingDataProvincias.sort((a, b) => b.consumoMedioEstablecimiento - a.consumoMedioEstablecimiento);
                this.topRankingDataProvincias = this.rankingDataProvincias.slice(0, 5);
                const elementosRestantes1 = this.rankingDataProvincias.slice(5);

                if(elementosRestantes1.length !== 0){
                  // Calcular consumo medio de los establecimientos restantes
                  let totalEstablecimientosRestantes = 0;
                  let totalConsumoRestantes = 0;
                  for (const establecimiento of elementosRestantes1) {
                    totalEstablecimientosRestantes += establecimiento.nEstablecimientos;
                    totalConsumoRestantes += establecimiento.consumoTotal;
                  }
                  const consumoMedioEstablecimientosRestantes = totalConsumoRestantes / totalEstablecimientosRestantes;
                  const establecimientoRestantes: RankingProvincias = {
                    name: 'Restantes',
                    nEstablecimientos: totalEstablecimientosRestantes,
                    consumosTotales: [], // Puedes ajustar esto según tu estructura
                    consumoMedioEstablecimiento: consumoMedioEstablecimientosRestantes,
                    consumoTotal: totalConsumoRestantes,
                  };
                  const listaFinal = this.topRankingDataProvincias.concat([establecimientoRestantes]);
                  this.topRankingDataProvincias = listaFinal;
                }
              }
            }, error:err =>{
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            }, complete:()=>{
              this.provinciasConseguido = true;
              if (this.rankingInfoConseguida && this.rankingCervezasInfoConseguida && this.mediaCervezasConseguida && this.diarioCervezasConseguida && this.provinciasConseguido) {
                this.mostrarSnackbar("Las gráficas han terminado de cargarse");
              }
            }
          });

        //RANKING CERVEZAS SEMANAL
          //Obtener el mismo día de la fecha actual pero el año anterior
          const añoActual = this.fechaActual.getFullYear();
          const añoAnterior = añoActual - 1;
          const fechaAñoAnterior = new Date(añoAnterior, this.fechaActual.getMonth(), this.fechaActual.getDate());
          const fechaActual11 = new Date(añoActual, this.fechaActual.getMonth(), this.fechaActual.getDate());
          this.selectedDateCervezasSemanal.setValue({start: fechaAñoAnterior, end: fechaActual11});
          const paises: string [] = []
          paises.push("España");
          const establecimientoData1 = new FormData();
          establecimientoData1.append('start', this.convertirFecha(fechaAñoAnterior));
          establecimientoData1.append('end', this.obtenerDiaSiguiente(this.convertirFecha(this.fechaActual)));
          establecimientoData1.append('paises', JSON.stringify(paises));
          establecimientoData1.append('desglose', "weeks");
          this.rankingCervezasSubscription = this.deviceService.getEstConsumos(establecimientoData1).subscribe({
            next: resp =>{
              if(resp.length == 0){
                this.semanalDatos = false;
              } else {
                this.semanalDatos = true;
                let consumoTotales: { id: number; type: string; consumo: number }[] = [];
                for(let i=0; i<resp.length; i++){
                  //Reiniciamos los valores
                  let consumoTotal1: number = 0;
                  consumoTotales = [];
                  for (const key in resp[i].beertypes) {
                    if (resp[i].beertypes.hasOwnProperty(key)) {
                      const beerType = resp[i].beertypes[key];
                      if (beerType) {
                        // Obtener el nombre de la cerveza y consumo total
                        const beerName = beerType.type;
                        const beerID = beerType.id;
                        consumoTotal1 += beerType.consume;
                  
                        // Verificar si ya existe la cerveza en consumosTotales
                        const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);
    
                        if(parseFloat(beerType.consume.toFixed(2)) > 0  && this.userData.pro_id == 4){
                          if (existingBeerIndex !== -1) {
                            consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                          } else {  
                            consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                          }
                        } else {
                          if(this.userData.pro_id !== 4){
                            if (existingBeerIndex !== -1) {
                              consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                            } else {  
                              consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                            }
                          }
                        }
                      }
                    }
                  }
                  const data = {
                    week: resp[i].week,
                    month: resp[i].month,
                    year: resp[i].year
                  };
                  const consumoTotalRedondeado = consumoTotal1.toFixed(2);
                  const establecimientoRanking: any = {
                    name: resp[i].name,
                    date: this.formatDateSemanaAño(data),
                    consumosTotales: consumoTotales, 
                    consumoTotal: parseFloat(consumoTotalRedondeado),
                  };
                  this.rankingDataSemanal.push(establecimientoRanking);
                }
                this.rankingDataSemanal.sort((a, b) => {
                  const dateA = a.date;
                  const dateB = b.date;
                  return dateA.localeCompare(dateB);
                });
              }
            },error:err =>{
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            },complete:()=>{
              this.rankingCervezasInfoConseguida = true
              if (this.rankingInfoConseguida && this.rankingCervezasInfoConseguida && this.mediaCervezasConseguida && this.diarioCervezasConseguida && this.provinciasConseguido) {
                this.mostrarSnackbar("Las gráficas han terminado de cargarse");
              }
            }
          });

        //CERVEZAS DIARIO
          const fechaActual1 = new Date();
          // Restarle siete días
          fechaActual1.setDate(fechaActual1.getDate() - 7);
          // Obtener el año, mes y día en formato "YYYY-MM-DD"
          const año3 = fechaActual1.getFullYear();
          const mes3 = (fechaActual1.getMonth() + 1).toString().padStart(2, '0'); // Se suma 1 porque en JavaScript los meses van de 0 a 11
          const dia3 = fechaActual1.getDate().toString().padStart(2, '0');
          // Formatear la fecha en el formato deseado
          const fechaFormateada3 = `${año3}-${mes3}-${dia3}`;
          this.selectedDateDiario.setValue({start: fechaFormateada3, end: this.convertirFecha(this.fechaActual)});
          const paises2: string [] = []
          paises2.push("España");
          const establecimientoData3 = new FormData();
          establecimientoData3.append('start', fechaFormateada3);
          establecimientoData3.append('end', this.obtenerDiaSiguiente(this.convertirFecha(this.fechaActual)));
          establecimientoData3.append('paises', JSON.stringify(paises2));
          establecimientoData3.append('desglose', "days");
          this.diasCervezaSubscription = this.deviceService.getEstConsumos(establecimientoData3).subscribe({
            next: resp =>{
              if(resp.length == 0){
                this.diarioDatos = false;
              } else {
                this.diarioDatos = true;
                let consumoTotales: { id: number; type: string; consumo: number }[] = [];
                for(let i=0; i<resp.length; i++){
                  //Reiniciamos los valores
                  let consumoTotal1: number = 0;
                  consumoTotales = [];
                  for (const key in resp[i].beertypes) {
                    if (resp[i].beertypes.hasOwnProperty(key)) {
                      const beerType = resp[i].beertypes[key];
                      if (beerType) {
                        // Obtener el nombre de la cerveza y consumo total
                        const beerName = beerType.type;
                        consumoTotal1 += beerType.consume;
                        const beerID = beerType.id;
                        const consumo = parseFloat(beerType.consume.toFixed(2));
                  
                        // Verificar si ya existe la cerveza en consumosTotales
                        const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);
    
                        if(parseFloat(beerType.consume.toFixed(2)) > 0  && this.userData.pro_id == 4){
                          if (existingBeerIndex !== -1) {
                            consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                          } else {  
                            consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                          }
                        } else {
                          if(this.userData.pro_id !== 4){
                            if (existingBeerIndex !== -1) {
                              consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                            } else {  
                              consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                            }
                          }
                        }
                      }
                    }
                  }
                  const data = {
                    day: resp[i].day,
                    month: resp[i].month,
                    year: resp[i].year
                  };
                  const consumoTotalRedondeado = consumoTotal1.toFixed(2);
                  const establecimientoRanking: any = {
                    name: resp[i].name,
                    date: this.formatDateDiaMesAño(data),
                    consumosTotales: consumoTotales, // copia para evitar referencias directas
                    consumoTotal: parseFloat(consumoTotalRedondeado),
                  };
                  this.rankingDataDiario.push(establecimientoRanking);
                }
                this.rankingDataDiario.sort((a, b) => {
                  const dateA = a.date;
                  const dateB = b.date;
                  return dateA.localeCompare(dateB);
                });
              }
            },error:err =>{
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            },complete:()=>{
              this.diarioCervezasConseguida = true
              if (this.rankingInfoConseguida && this.rankingCervezasInfoConseguida && this.mediaCervezasConseguida && this.diarioCervezasConseguida && this.provinciasConseguido) {
                this.mostrarSnackbar("Las gráficas han terminado de cargarse");
              }
            }
          });

        //MEDIA HORAS
        const fechaActual3 = new Date();
        // Restarle siete días
        fechaActual3.setDate(fechaActual3.getDate() - 7);
        // Obtener el año, mes y día en formato "YYYY-MM-DD"
        const año = fechaActual3.getFullYear();
        const mes = (fechaActual3.getMonth() + 1).toString().padStart(2, '0'); // Se suma 1 porque en JavaScript los meses van de 0 a 11
        const dia = fechaActual3.getDate().toString().padStart(2, '0');
        // Formatear la fecha en el formato deseado
        const fechaFormateada2 = `${año}-${mes}-${dia}`;
        this.selectedDateMediaHoras.setValue({start: fechaFormateada2, end: this.convertirFecha(this.fechaActual)});
        const paises1: string [] = []
        paises1.push("España");
        const establecimientoData2 = new FormData();
        establecimientoData2.append('start', fechaFormateada2);
        establecimientoData2.append('end', this.convertirFecha(this.fechaActual));
        establecimientoData2.append('paises', JSON.stringify(paises1));
        establecimientoData2.append('desglose', "hours");
        this.mediaHorasSubscription = this.deviceService.getEstConsumos(establecimientoData2).subscribe({
          next: resp =>{
            console.log(resp);
            if(resp.length == 0){
              this.mediaHorasDatos = false;
            }
            //Mirar que haya respuesta ya que sino al mirar las beertypes va a dar error
            if(resp.length != 0){
              this.mediaHorasDatos = true;
              const consumoPorHora1: any = [];
              //Inicializar los tipos de cerveza
              for (let hora = 0; hora < 24; hora++) {
                const horaData: any = {};
                for (const key in resp[0].beertypes) {
                  if (resp[0].beertypes.hasOwnProperty(key)) {
                    const beerType = resp[0].beertypes[key];
                    if (beerType) {
                      horaData[beerType.type] = 0;
                      horaData["hora"] = hora;
                    }
                  }
                }
                consumoPorHora1.push(horaData);
              }
              //Sumar el consumo en cada hora
              for (let i = 0; i < resp.length; i++) {
                const hora = resp[i].hour;
                for (const key in resp[i].beertypes) {
                  if (resp[i].beertypes.hasOwnProperty(key)) {
                    const beerType = resp[i].beertypes[key];
                    if (beerType) {
                      consumoPorHora1[hora][beerType.type] += beerType.consume;
                      consumoPorHora1[hora][beerType.type] = parseFloat(consumoPorHora1[hora][beerType.type].toFixed(2));
                    }
                  }
                }
              }
              // Calcular la media semanal por hora
              for (let hora = 0; hora < 24; hora++) {
                for (const beerType in consumoPorHora1[hora]) {
                  if (consumoPorHora1[hora].hasOwnProperty(beerType)) {
                    if(beerType != "hora"){
                      consumoPorHora1[hora][beerType] /= 7;
                      consumoPorHora1[hora][beerType] = +consumoPorHora1[hora][beerType].toFixed(2);
                    }
                  }
                }
              }
              this.rankingConsumoPorHora = consumoPorHora1;
              console.log(this.rankingConsumoPorHora);
            }
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete:()=>{
            this.mediaCervezasConseguida = true
            if (this.rankingInfoConseguida && this.rankingCervezasInfoConseguida && this.mediaCervezasConseguida && this.diarioCervezasConseguida && this.provinciasConseguido) {
              this.mostrarSnackbar("Las gráficas han terminado de cargarse");
            }
          }
        });
      }
    });
    this.tablaBusquedaSubscription = this.deviceService.getBusquedaConFiltros().subscribe({
      next: resp =>{
        for(let i=0; i<resp.length; i++){
          this.tablaDeFiltros.push({
            id: resp[i].id,
            name: resp[i].name,
            filters: resp[i].filters,
            created_at: resp[i].created_at,
            updated_at: resp[i].updated_at,
            user_id: resp[i].user_id
          });
        }
      }, error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const nombreFiltro = typeof value === 'string' ? value : value?.name;
            return nombreFiltro ? this._filter(nombreFiltro as string) : this.tablaDeFiltros.slice();
          }),
        );
      }
    });
  }

  ordenarEstablecimientos(){
    this.establecimientos.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
          return -1;
      }
      if (nameA > nameB) {
          return 1;
      }
      return 0;
    });
  }

  ordenarEstablecimientosCopia(){
    this.establecimientosCopia.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
          return -1;
      }
      if (nameA > nameB) {
          return 1;
      }
      return 0;
    });
  }

  asignarConsumo(idCerveza: number, nuevoConsumo: number): void {
    const cerveza = this.cervezas.find(c => c.value === idCerveza);
    if (cerveza) {
      cerveza.consumoTotal = nuevoConsumo;
    }
  }
  
  //AUTOCOMPLETE

    guardarFiltro() {
      // Verificar que el nombre del filtro no esté vacío
      const nombreFiltroTrimmed = this.nombreFiltro.trim();
      if (nombreFiltroTrimmed === '') {
        return; // No hacer nada si el nombre del filtro está vacío
      }
      // Verificar si el nombre del filtro ya está en la lista
      if (this.tablaDeFiltros.some((filtro:any) => filtro.name === nombreFiltroTrimmed)) {
        //alert('¡Ya existe una búsqueda con este nombre en la lista!');
        this.toastr.error('','¡Ya existe una búsqueda con este nombre!',{
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
        if (!this.waitAfterSave) {
          this.waitAfterSave = true;
        }
        setTimeout(() => {
          this.waitAfterSave = false;
        },3500)
        return;
      }
      const todasLasVariablesVacias =
      this.selectedEstablecimiento.length === 0 &&
      this.selectedLocalidades.length === 0 &&
      this.selectedProvincias.length === 0 &&
      this.selectedComunidades.length === 0 &&
      this.selectedPaises.length === 0;
      if (todasLasVariablesVacias) {
        //alert('Es necesario seleccionar una ubicación o un establecimiento.');
        this.toastr.warning('','¡Es necesario seleccionar una ubicación o un establecimiento!',{
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font',
          //positionClass: 'toast-top-center'
        });
        if (!this.waitAfterSave) {
          this.waitAfterSave = true;
        }
        setTimeout(() => {
          this.waitAfterSave = false;
        },3500)
        return;
      }
      this.startGlobal = this.convertirFechaInicio(this.selectedDateGlobal);
      this.endGlobal = this.convertirFechaFin(this.selectedDateGlobal);

      // Validación de fechas
      if (
        !this.esFechaValida(this.startGlobal) ||
        !this.esFechaValida(this.endGlobal)
      ) {
        this.toastr.error('', '¡Debe seleccionar una fecha de inicio y fin válida!', {
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
        if (!this.waitAfterSave) {
          this.waitAfterSave = true;
        }
        setTimeout(() => {
          this.waitAfterSave = false;
        }, 3500);
        return;
      }
      let desglose;
      if(this.opcionSeleccionada=="porTotal"){
        desglose = "total";
      }
      if(this.opcionSeleccionada=="porHoras"){
        desglose = "hours";
      }
      if(this.opcionSeleccionada=="porDia"){
        desglose = "days";
      }
      if(this.opcionSeleccionada=="porSemana"){
        desglose = "weeks";
      }
      if(this.opcionSeleccionada=="porMes"){
        desglose = "months";
      }
      const filtro = {
        start: this.startGlobal,
        end: this.convertirFechaFin(this.selectedDateGlobal),
        establecimientos: this.selectedEstablecimiento,
        localidades: this.selectedLocalidades,
        provincias: this.selectedProvincias,
        comunidades: this.selectedComunidades,
        paises: this.selectedPaises,
        cervezas: this.selectedCervezas,
        desglose: desglose
      }
      const jsonFiltroData = JSON.stringify(filtro);
      const busquedaData = new FormData();
      busquedaData.append('name', nombreFiltroTrimmed);
      busquedaData.append('filters', jsonFiltroData);
      busquedaData.append('_method', 'PUT');
      this.crearBusquedaSubscription = this.deviceService.crearBusquedaConFiltros(busquedaData).subscribe({
        next: resp =>{
          console.log(resp);
          this.tablaDeFiltros.push({
            id: resp.id,
            name: resp.name,
            filters: resp.filters,
            created_at: resp.created_at,
            updated_at: resp.updated_at,
            user_id: resp.user_id
          });
        }, error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () =>{
          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => {
              const nombreFiltro = typeof value === 'string' ? value : value?.name;
              return nombreFiltro ? this._filter(nombreFiltro as string) : this.tablaDeFiltros.slice();
            }),
          );
          //alert('¡La búsqueda ha sido registrada!');
          this.toastr.success('','¡La búsqueda ha sido registrada!',{
            timeOut: 3500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          },3500)
          this.nombreFiltro = '';
          /*this.tablaBusquedaSubscription = this.deviceService.getBusquedaConFiltros().subscribe({
            next: resp =>{
              for(let i= resp.length-1; i<resp.length; i++){
                this.tablaDeFiltros.push({
                  id: resp[i].id,
                  name: resp[i].name,
                  filters: resp[i].filters,
                  created_at: resp[i].created_at,
                  updated_at: resp[i].updated_at,
                  user_id: resp[i].user_id
                });
              }
            }, error:err =>{
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            }, complete: () =>{
              this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map(value => {
                  const nombreFiltro = typeof value === 'string' ? value : value?.name;
                  return nombreFiltro ? this._filter(nombreFiltro as string) : this.tablaDeFiltros.slice();
                }),
              )
            }
          });*/
        }
      });
    }

    esFechaValida(fecha: string): boolean {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(fecha);
    }

    displayFn(filtro: Filtros): string {
      return filtro && filtro.name ? filtro.name : '';
    }

    limpiarSeleccion(): void {
      this.myControl.setValue('');
      this.selectedEstablecimiento = [];
      this.selectedLocalidades = [];
      this.selectedProvincias = [];
      this.selectedComunidades = [];
      this.selectedPaises = [];
      this.selectedCervezas = [];
      this.opcionSeleccionada = "porTotal";
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const nombreFiltro = typeof value === 'string' ? value : value?.name;
          return nombreFiltro ? this._filter(nombreFiltro as string) : this.tablaDeFiltros.slice();
        }),
      );
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
      const selectedFiltro: string | Filtros | null = this.myControl.value;
      console.log(selectedFiltro);
      if (selectedFiltro && typeof selectedFiltro !== 'string') {
        const filtros = JSON.parse(selectedFiltro.filters);
        this.selectedEstablecimiento = filtros.establecimientos;
        this.selectedDateGlobal.patchValue({
          start: filtros.start,
          end: filtros.end
        });
        this.selectedLocalidades = filtros.localidades;
        this.selectedProvincias = filtros.provincias;
        this.selectedComunidades = filtros.comunidades;
        this.selectedPaises = filtros.paises;
        this.selectedCervezas = filtros.cervezas;
        let desglose = "porTotal";
        if(filtros.desglose =="total"){
          desglose = "porTotal";
        }
        if(filtros.desglose =="hours"){
          desglose = "porHoras";
        }
        if(filtros.desglose =="days"){
          desglose = "porDia";
        }
        if(filtros.desglose =="weeks"){
          desglose = "porSemana";
        }
        if(filtros.desglose =="months"){
          desglose = "porMes";
        }
        this.opcionSeleccionada = desglose;
      }
      /*if (selectedFiltro && typeof selectedFiltro !== 'string') {
        this.opcionSeleccionada = selectedFiltro.intervalo;
        this.selectedEstablecimiento = selectedFiltro.establecimientos;
        this.selectedLocalidades = selectedFiltro.localidades;
        this.selectedProvincias = selectedFiltro.provincias;
        this.selectedComunidades = selectedFiltro.comunidades;
        this.selectedPaises = selectedFiltro.paises;
        this.selectedCervezas = selectedFiltro.cervezas;
      }*/
    }

    busquedaSeleccionada(): boolean{
      const selectedFiltro: string | Filtros | null = this.myControl.value;
      if (selectedFiltro && typeof selectedFiltro !== 'string') {
        return true;
      } else {
        return false;
      }
    }

    eliminarBusqueda(){
      const selectedFiltro: string | Filtros | null = this.myControl.value;
      console.log(selectedFiltro);
      if (selectedFiltro && typeof selectedFiltro !== 'string') {
        const busquedaData = new FormData();
        busquedaData.append('_method', 'DELETE');
        busquedaData.append('filter_id', selectedFiltro.id.toString());
        this.eliminarBusquedaSubscription = this.deviceService.eliminarBusquedaConFiltros(busquedaData).subscribe({
          next: resp =>{
          }, error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete: () =>{
            //Eliminar de la tabla el elemnento que tenga el id seleccionado.
            this.tablaDeFiltros = this.tablaDeFiltros.filter(busqueda => busqueda.id !== selectedFiltro.id);
            //Vaciar las opciones seleccionadas
            this.myControl.setValue("");
            this.selectedEstablecimiento = [];
            this.selectedLocalidades = [];
            this.selectedProvincias = [];
            this.selectedComunidades = [];
            this.selectedPaises = [];
            this.selectedCervezas = [];
            this.opcionSeleccionada = "porTotal";
          }
        });
      }
    }

    private _filter(name: string): Filtros[] {
      const filterValue = name.toLowerCase();

      return this.tablaDeFiltros.filter((option:any) => option.name.toLowerCase().includes(filterValue));
    }


  mostrarSnackbar(mensaje: string) {
    /*this._snackBar.open(mensaje, 'Cerrar', {
      duration: 6000,
    });*/
    //Las gráficas han terminado de cargarse
  }

  onTabFocusChange(event: any) {
    if (event.tab.textLabel === 'ESTADÍSTICAS') {
      this.estadisticasActivas = true;
      this.graficasActivas = false;
    }
    if (event.tab.textLabel === 'GRÁFICAS') {
      this.estadisticasActivas = false;
      this.graficasActivas = true;
      this.loadChartsGraficas();
    }
  }

  destroyCharts() {
    Object.values(this.charts).forEach((chart) => {
      chart.destroy();
    });
    this.charts = [];
  }

  soloDosDecimalesConComa(numero: number){
    //return parseFloat(numero.toFixed(2));
    return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
  }

  filtrarFechasMismoMesAnio(fechas: string[]): string[] {
    this.stringFechaConsumoDiarioEspaña = "Fecha (Día/Mes/Año)";
    // Verificar si todas las fechas tienen el mismo año
    const mismoAnio = fechas.every(fecha => fecha.split('/')[2] === fechas[0].split('/')[2]);
    // Si todas las fechas tienen el mismo año, verificar si también comparten el mismo mes
    if (mismoAnio) {
        const mismoMes = fechas.every(fecha => fecha.split('/').slice(1, 3).join('/') === fechas[0].split('/').slice(1, 3).join('/'));
        // Si todas las fechas tienen el mismo mes, devolver solo el día
        if (mismoMes) {
          this.stringFechaConsumoDiarioEspaña = "Fecha (Día)";
            return fechas.map(fecha => fecha.split('/')[0]);
        } else {
            // Si no comparten el mismo mes, devolver solo día y mes
            this.stringFechaConsumoDiarioEspaña = "Fecha (Día/Mes)";
            return fechas.map(fecha => fecha.split('/').slice(0, 2).join('/'));
        }
    } else {
        // Si no comparten el mismo año, devolver las fechas originales
        return fechas;
    }
  }

  filtrarSemanasMismoAnio(semanas: string[]): string[] {
    this.stringFechaConsumoSemanalCervezas = "Semanas (Año/Semana)"
    // Verificar si todas las semanas tienen el mismo año
    if(semanas.length != 0){
      const mismoAnio = semanas.every(semana => semana.split('/')[0] === semanas[0].split('/')[0]);
      // Si todas las semanas tienen el mismo año, devolver solo el número de la semana
      if (mismoAnio) {
          const anio = semanas[0].split('/')[0];
          this.stringFechaConsumoSemanalCervezas = `Semanas del año ${anio}`;
          return semanas.map(semana => semana.split('/')[1]);
      } else {
          // Si no comparten el mismo año, devolver las semanas originales
          this.stringFechaConsumoSemanalCervezas = "Semanas (Año/Semana)"
          return semanas;
      }
    } else {
      return semanas;
    }
  }

  loadChartsGraficas(){
    Chart.register(zoomPlugin);
    this.destroyCharts();
    setTimeout(() => {
      // Función para devolver los decimales con comas y con un máximo de dos decimales
      const soloDosDecimalesConComa = (numero: any) => {
        return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
      };

      //DATOS RANKING ESTABLECIMIENTOS
      if(this.rankingEstablecimientosDatos){
        const canvasRanking: any = document.getElementById('Ranking');
        const ctxRanking = canvasRanking.getContext('2d');

        const labels = [];
        let datasets: any = []; 
        const tiposDeCerveza: any = [];
        for (let j = 0; j < this.topRankingData1.length; j++) {
          labels.push(this.topRankingData1[j].name);
          for (let i = 0; i < this.topRankingData1[j].consumosTotales.length; i++) {
              const cerveza = this.topRankingData1[j].consumosTotales[i];
              const cervezaInfo = {
                  id: cerveza.id,
                  nombre: cerveza.type
              };
              // Verificar si ya hemos agregado esta cerveza por su ID
              const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
              if (!existingCerveza) {
                tiposDeCerveza.push(cervezaInfo);
              }
          }
        }
        for(let i=0; i<tiposDeCerveza.length; i++){
          let data = new Array(this.topRankingData1.length).fill(null); 
          for(let j=0; j<this.topRankingData1.length; j++){
            for(let z=0; z<this.topRankingData1[j].consumosTotales.length; z++){
              const cervezaActual = this.topRankingData1[j].consumosTotales[z];
              if(cervezaActual.id === tiposDeCerveza[i].id){
                data[j] = cervezaActual.consumo;
              }
            }
          }
          datasets.push({
            label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
            data: data // Consumo de cada tipo de cerveza
          })
        }
        const data = {
          labels: labels,
          datasets: datasets,
        };
        // GRÁFICO RANKING ESTABLECIMIENTOS
        let delayed: any;
        this.chartRanking = new Chart(ctxRanking, {
          type: 'bar',
          data: data,
          options: {
            animation: {
              onComplete: () => {
                delayed = true;
              },
              delay: (context) => {
                let delay = 0;
                if (context.type === 'data' && context.mode === 'default' && !delayed) {
                  delay = context.dataIndex * 300 + context.datasetIndex * 100;
                }
                return delay;
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "top",
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  }
                }
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'xy',
                  onZoomComplete({chart}) {
                    chart.update('none');
                  }
                },
              },
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            scales: {
              y: {
                beginAtZero: true,
                position: 'left',
                title: {
                  display: true,
                  text: 'Litros',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    bottom: 20
                  },
                },
                stacked: true,
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Establecimientos',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    top: 20
                  }
                },
                stacked: true,
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                },
                grid: {
                  display: false
                }
              }
            },
            elements: {
              bar: {
                borderWidth: 2,
              }
            }
          }
        });
        this.charts.push(this.chartRanking);
      }

      //DATOS RANKING CERVEZAS SEMANAL
      if(this.semanalDatos){
        const canvasRankingCervezas: any = document.getElementById('rankingCervezas');
        const ctxRankingCervezas = canvasRankingCervezas.getContext('2d');

        /*let semanasFecha: any = [];
        const consumosPorTipoSemanal: { label: string, data: number[] }[] = [];
        for (const semana of this.rankingDataSemanal) {
          semanasFecha.push(semana.date);
          for (const tipoCerveza in semana.consumosTotales) {
            if (semana.consumosTotales.hasOwnProperty(tipoCerveza)) {
              const consumoTipo = semana.consumosTotales[tipoCerveza];
              //console.log(`Tipo de cerveza: ${consumoTipo.type}, Consumo: ${consumoTipo.consumo}`);
              // Buscar si ya existe un objeto para esta cerveza
              const existente = consumosPorTipoSemanal.find(item => item.label === consumoTipo.type);
              if (existente) {
                // Si ya existe, agregar el consumo a su lista
                existente.data.push(consumoTipo.consumo);
              } else {
                // Si no existe, crear un nuevo objeto y agregarlo a la lista
                consumosPorTipoSemanal.push({ label: consumoTipo.type, data: [consumoTipo.consumo] });
              }
            }
          }
        }
        semanasFecha = this.filtrarSemanasMismoAnio(semanasFecha);
        let datasetsConsumosRankingCervezas = [];
        for (const consumoTipo of consumosPorTipoSemanal) {
          datasetsConsumosRankingCervezas.push({
            label: consumoTipo.label,
            data: consumoTipo.data,
            borderWidth: 1,
            pointBorderWidth: 2,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 2,
            fill: false,
            yAxisID: 'y'
          });
        }*/

        let labels = [];
        let datasets: any = []; 
        const tiposDeCerveza: any = [];
        for (let j = 0; j < this.rankingDataSemanal.length; j++) {
          labels.push(this.rankingDataSemanal[j].date);
          for (let i = 0; i < this.rankingDataSemanal[j].consumosTotales.length; i++) {
              const cerveza = this.rankingDataSemanal[j].consumosTotales[i];
              const cervezaInfo = {
                  id: cerveza.id,
                  nombre: cerveza.type
              };
              // Verificar si ya hemos agregado esta cerveza por su ID
              const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
              if (!existingCerveza) {
                tiposDeCerveza.push(cervezaInfo);
              }
          }
        }
        for(let i=0; i<tiposDeCerveza.length; i++){
          let data = new Array(this.rankingDataSemanal.length).fill(null); 
          for(let j=0; j<this.rankingDataSemanal.length; j++){
            for(let z=0; z<this.rankingDataSemanal[j].consumosTotales.length; z++){
              const cervezaActual = this.rankingDataSemanal[j].consumosTotales[z];
              if(cervezaActual.id === tiposDeCerveza[i].id){
                data[j] = cervezaActual.consumo;
              }
            }
          }
          datasets.push({
            label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
            data: data // Consumo de cada tipo de cerveza
          })
        }
        labels = this.filtrarSemanasMismoAnio(labels);
        const data = {
          labels: labels,
          datasets: datasets,
        };

        // GRÁFICO RANKING CERVEZAS SEMANAL
        this.chartRankingCervezas = new Chart(ctxRankingCervezas, {
          type: 'line',
          data: data,
          options: {
            animation: {
              duration: 1000,
              easing: 'easeInOutQuad',
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "top",
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  }
                }
              },
              tooltip: {
                usePointStyle: true,
                callbacks: {
                  labelPointStyle: function(context) {
                    return {
                        pointStyle: 'rect',
                        rotation: 0,
                    };
                  },
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.y);
                    return `${label}: ${value}`;
                  },
                }
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'xy',
                  onZoomComplete({chart}) {
                    // This update is needed to display up to date zoom level in the title.
                    // Without this, previous zoom level is displayed.
                    // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                    chart.update('none');
                  }
                },
              },
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            scales: {
              y: {
                beginAtZero: true,
                position: 'left',
                title: {
                  display: true,
                  text: 'Consumo (Litros)',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    bottom: 20
                  },
                },
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                }
              },
              x: {
                title: {
                  display: true,
                  text: this.stringFechaConsumoSemanalCervezas,
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    top: 20
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  //autoSkip: false, //Mostrar todo el contenido de las labels en el eje x
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        this.charts.push(this.chartRankingCervezas);
      }

      //DATOS MEDIAS HORA
      if(this.mediaHorasDatos){
        //Solo se carga la gráfica en caso de haber datos
        const canvasMediasHoras: any = document.getElementById('mediaHoras');
        const ctxMediasHoras = canvasMediasHoras.getContext('2d');
        const labels = []; // Etiquetas para las horas
        const consumosMedioHoras: { label: string, data: number[] }[] = [];
        
        for (let hora = 0; hora < 24; hora++) {
          const horaFormateada = hora.toString().padStart(2, '0');
          labels.push(`${horaFormateada}:00`);
        
          const datosHora = this.rankingConsumoPorHora[hora];
          if (datosHora) {
            for (const tipoCerveza in datosHora) {
              if (datosHora.hasOwnProperty(tipoCerveza)) {
                const consumo = datosHora[tipoCerveza];
                // Buscar la posición del tipo de cerveza en consumosMedioHoras
                const index = consumosMedioHoras.findIndex(item => item.label === tipoCerveza);
                if (index !== -1) {
                  // Si ya existe, agregar el consumo a la lista existente
                  consumosMedioHoras[index].data.push(consumo);
                } else {
                  // Si no existe, agregar un nuevo elemento a consumosMedioHoras
                  consumosMedioHoras.push({ label: tipoCerveza, data: [consumo] });
                }
              }
            }
          }
        }
        let datasetsConsumosMediosHoras = [];
        for (const consumoMedio of consumosMedioHoras) {
          if (consumoMedio.label !== "hora") {
            // Verificar si todos los consumos son 0
            const allZero = consumoMedio.data.every(value => value === 0);
            if (!allZero) {
              // Reemplazar 0 por null en consumoMedio.data
              const newData = consumoMedio.data.map(value => value === 0 ? null : value);
              datasetsConsumosMediosHoras.push({
                label: consumoMedio.label,
                data: newData,
                borderWidth: 2,
                pointBorderWidth: 1,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 5,
                fill: true,
                yAxisID: 'y',
                pointBorderColor: '#fff',
              });
            }
          }
        }
        const data = {
          labels: labels,
          datasets: datasetsConsumosMediosHoras
        };

       // GRÁFICO MEDIA HORAS
        this.chartMediasHoras = new Chart(ctxMediasHoras, {
          type: 'radar',
          data: data,
          options: {
            plugins: {
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.r);
                    return `${label}: ${value}`;
                  },
                },
              },
            },
            interaction: {
              mode: 'nearest',
              intersect: false,
            },
            elements: {
              line: {
                borderWidth: 3
              }
            },
            scales: {
              r: {
                angleLines: {
                  display: false
                },
                beginAtZero: true,
                pointLabels: {
                  font: {
                    size: 12,
                  },
                },
                ticks: {
                  callback: function (value) {
                    return value + ' L';
                  },
                  padding: 15
                },
                suggestedMin: 0,
              }
            }
          },
        });
        this.charts.push(this.chartMediasHoras);
      }

      //DATOS CONSUMO DIARIO
      if(this.diarioDatos){
        const canvasConsumoDiarioSemanal: any = document.getElementById('cervezasDiario');
        const ctxConsumoDiarioSemanal = canvasConsumoDiarioSemanal.getContext('2d');

        /*let diasFecha: any = [];
        const consumosPorTipoDiario: { label: string, data: number[] }[] = [];
        for (const dia of this.rankingDataDiario) {
          diasFecha.push(dia.date);
          for (const tipoCerveza in dia.consumosTotales) {
            if (dia.consumosTotales.hasOwnProperty(tipoCerveza)) {
              const consumoTipo = dia.consumosTotales[tipoCerveza];
              //console.log(`Tipo de cerveza: ${consumoTipo.type}, Consumo: ${consumoTipo.consumo}`);
              // Buscar si ya existe un objeto para esta cerveza
              const existente = consumosPorTipoDiario.find(item => item.label === consumoTipo.type);
              if (existente) {
                // Si ya existe, agregar el consumo a su lista
                existente.data.push(consumoTipo.consumo);
              } else {
                // Si no existe, crear un nuevo objeto y agregarlo a la lista
                consumosPorTipoDiario.push({ label: consumoTipo.type, data: [consumoTipo.consumo] });
              }
            }
          }
        }
        const compararFechas = (fechaA: any, fechaB: any) => {
          const dateA: any = new Date(fechaA.split('/').reverse().join('/'));
          const dateB: any = new Date(fechaB.split('/').reverse().join('/'));
          return dateA - dateB;
        };
        diasFecha = diasFecha.sort(compararFechas);
        diasFecha = this.filtrarFechasMismoMesAnio(diasFecha);
        let datasetsConsumosDiariosSemana = [];
        for (let i = 0; i < consumosPorTipoDiario.length; i++) {
          // Índice circular en backgroundColorsOpacos
          const indexColor = i % this.backgroundColorsOpacos.length;
          datasetsConsumosDiariosSemana.push({
            label: consumosPorTipoDiario[i].label,
            data: consumosPorTipoDiario[i].data,
            borderWidth: 2,
            pointBorderWidth: 1,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 5,
            fill: true,
            yAxisID: 'y',
            backgroundColor: this.backgroundColorsOpacos[indexColor],
            borderColor: this.borderColor[indexColor],
          });
        }
        const data1 = {
          labels: diasFecha,
          datasets: datasetsConsumosDiariosSemana
        };*/

        let labels = [];
        let datasets: any = []; 
        const tiposDeCerveza: any = [];
        for (let j = 0; j < this.rankingDataDiario.length; j++) {
          labels.push(this.rankingDataDiario[j].date);
          for (let i = 0; i < this.rankingDataDiario[j].consumosTotales.length; i++) {
              const cerveza = this.rankingDataDiario[j].consumosTotales[i];
              const cervezaInfo = {
                  id: cerveza.id,
                  nombre: cerveza.type
              };
              // Verificar si ya hemos agregado esta cerveza por su ID
              const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
              if (!existingCerveza) {
                tiposDeCerveza.push(cervezaInfo);
              }
          }
        }
        for(let i=0; i<tiposDeCerveza.length; i++){
          let data = new Array(this.rankingDataDiario.length).fill(null); 
          for(let j=0; j<this.rankingDataDiario.length; j++){
            for(let z=0; z<this.rankingDataDiario[j].consumosTotales.length; z++){
              const cervezaActual = this.rankingDataDiario[j].consumosTotales[z];
              if(cervezaActual.id === tiposDeCerveza[i].id){
                data[j] = cervezaActual.consumo;
              }
            }
          }
          // Índice circular en backgroundColorsOpacos
          const indexColor = i % this.backgroundColorsOpacos.length;
          datasets.push({
            label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
            data: data, // Consumo de cada tipo de cerveza
            fill: true,
            backgroundColor: this.backgroundColorsOpacos[indexColor],
            borderColor: this.borderColor[indexColor],
            borderWidth: 2,
            pointBorderWidth: 1,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 5,
          })
        }
        const compararFechas = (fechaA: any, fechaB: any) => {
          const dateA: any = new Date(fechaA.split('/').reverse().join('/'));
          const dateB: any = new Date(fechaB.split('/').reverse().join('/'));
          return dateA - dateB;
        };
        labels = labels.sort(compararFechas);
        labels = this.filtrarFechasMismoMesAnio(labels);
        const data = {
          labels: labels,
          datasets: datasets,
        };
        
        // GRÁFICO DIARIO SEMANAL
        this.chartDiarioSemana = new Chart(ctxConsumoDiarioSemanal, {
          type: 'line',
          data: data,
          options: {
            animation: {
              duration: 1000,
              easing: 'easeInOutQuad',
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              tooltip: {
                usePointStyle: true,
                callbacks: {
                  labelPointStyle: function(context) {
                    return {
                        pointStyle: 'rect',
                        rotation: 0,
                    };
                  },
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.y);
                    return `${label}: ${value}`;
                  },
                }
              },
              legend: {
                position: "top",
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  }
                }
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'xy',
                  onZoomComplete({chart}) {
                    // This update is needed to display up to date zoom level in the title.
                    // Without this, previous zoom level is displayed.
                    // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                    chart.update('none');
                  }
                },
              },
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            scales: {
              y: {
                stacked: true,
                beginAtZero: true,
                position: 'left',
                title: {
                  display: true,
                  text: 'Consumo (Litros)',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    bottom: 20
                  },
                },
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                },
              },
              x: {
                stacked: true,
                title: {
                  display: true,
                  text: this.stringFechaConsumoDiarioEspaña,
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    top: 20
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  //autoSkip: false, //Mostrar todo el contenido de las labels en el eje x
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        this.charts.push(this.chartDiarioSemana);
      }

      //DATOS CONSUMO PROVINCIAS
      if (this.provinciasDatos == true){
        const canvasProvinciasConsumo: any = document.getElementById('provinciasConsumo');
        const ctxProvinciasConsumo = canvasProvinciasConsumo.getContext('2d');
        let namesRankingProvincias = [];
        let consumoMedioRankingProvincias = [];
        for (const provincia of this.topRankingDataProvincias) {
          //Guradar los nombres de las provincias y los consumos
          namesRankingProvincias.push(provincia.name);
          consumoMedioRankingProvincias.push(provincia.consumoMedioEstablecimiento);
        }
        let datasetsConsumosProvinciaEstablecimientos = [];
        datasetsConsumosProvinciaEstablecimientos.push({
          label: "Consumo Medio ",
          data: consumoMedioRankingProvincias,
          borderWidth: 1,
          pointBorderWidth: 10,
          pointHoverRadius: 10,
          pointHoverBorderWidth: 1,
          pointRadius: 0,
          fill: true,
          yAxisID: 'y',
          backgroundColor: 'rgba(237, 177, 12, 0.2)',
          borderColor: 'rgb(237, 177, 12)', 
          pointBackgroundColor: 'rgb(237, 177, 12)', 
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(237, 177, 12)'
        });

        /*const nombresProvincias = [];
        for(let i=0; i<this.consumoProvinciaTop.length; i++){
          nombresProvincias.push(this.consumoProvinciaTop[i].name);
        }
        let datasetsConsumosProvinciaEstablecimientos = [];
        const consumosMediosPorEstablecimientoEstrella = [];
        for(let i=0; i<this.consumoProvinciaTop.length; i++){
          consumosMediosPorEstablecimientoEstrella.push(this.consumoProvinciaTop[i].consumoMedioTotal);
        }
        datasetsConsumosProvinciaEstablecimientos.push({
          label: 'Consumo Total',
          data: consumosMediosPorEstablecimientoEstrella,
          fill: true,
          backgroundColor: 'rgba(237, 177, 12, 0.2)',
          borderColor: 'rgb(237, 177, 12)', 
          pointBackgroundColor: 'rgb(237, 177, 12)', 
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(237, 177, 12)'
        });*/

        // GRÁFICO PROVINCIAS CONSUMOS
        this.chartProvinciasEstablecimientos = new Chart(ctxProvinciasConsumo, {
          type: 'bar',
          data: {
            labels: namesRankingProvincias,
            datasets: datasetsConsumosProvinciaEstablecimientos
          },
          options: {
            indexAxis: 'y',
            elements: {
              bar: {
                borderWidth: 2,
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top',
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.x);
                    return `${label}: ${value}`;
                  },
                }
              },
              zoom: {
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                zoom: {
                  wheel: {
                    enabled: true,
                  },
                  pinch: {
                    enabled: true
                  },
                  mode: 'xy',
                  onZoomComplete({chart}) {
                    // This update is needed to display up to date zoom level in the title.
                    // Without this, previous zoom level is displayed.
                    // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                    chart.update('none');
                  }
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                position: 'left',
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                },
                grid: {
                  display: false
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Litros',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    top: 20
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                  //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        this.charts.push(this.chartProvinciasEstablecimientos);
      }
    },0)
    this.rakingEstablecimientosCambiadaCargarda = true;
    this.mediaHorasCambiadaCargada = true;
    this.semanalEspanaCambiadaCargada = true;
    this.diarioCambiadaCargada = true;
    this.provinciasCambiadaCargada = true;
  }

  resetZoomRanking(){
    if(this.chartRanking){
      this.chartRanking.resetZoom();
    }
  }
  resetZoomSemanal(){
    if(this.chartRankingCervezas){
      this.chartRankingCervezas.resetZoom();
    }
  }
  resetZoomDiario(){
    if(this.chartDiarioSemana){
      this.chartDiarioSemana.resetZoom();
    }
  }
  resetZoomProvincia(){
    if(this.chartProvinciasEstablecimientos){
      this.chartProvinciasEstablecimientos.resetZoom();
    }
  }

  destroyChart(chartToRemove: Chart) {
    const indexToRemove = this.charts.indexOf(chartToRemove);
    if (indexToRemove !== -1) {
      chartToRemove.destroy();
      this.charts.splice(indexToRemove, 1);
    } else {
      //console.log('El gráfico no está en la lista.');
    }
  }

  cambiarFechaRankingEstablecimientos() {
    this.rakingEstablecimientosCambiadaCargarda = false;
    const startValue = this.selectedDateTopEstablecimientos.get('start')?.value;
    const endValue = this.selectedDateTopEstablecimientos.get('end')?.value;
    if(startValue != null && endValue != null){
      this.startTopEstablecimientos = this.convertirFechaInicio(this.selectedDateTopEstablecimientos);
      this.endTopEstablecimientos = this.convertirFechaFin(this.selectedDateTopEstablecimientos);
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartRanking);;
      const establecimientoData = new FormData();
      establecimientoData.append('start', this.startTopEstablecimientos);
      establecimientoData.append('end', this.obtenerDiaSiguiente(this.endTopEstablecimientos));
      establecimientoData.append('establecimientos', JSON.stringify(this.establecimientosId));
      establecimientoData.append('desglose', "total");
      this.rankingData1 = [];
      this.topRankingData1 = [];
      this.consumoTotalesTotalesPorCerveza = [];
      this.rankingSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
        next: resp =>{      
          if(resp.length == 0){
            this.rankingEstablecimientosDatos = false;
          } else {
            this.rankingEstablecimientosDatos = true;
            //Suma total de todos los establecimientos
            let consumoTotales: { id: number; type: string; consumo: number }[] = [];
            //Inicializamos los consumos totales 
            /*const listaDeCervezasConConsumo: Cervezas[] = this.cervezas.map(cerveza => ({
              ...cerveza,
              consumoTotal: 0,
            }));
            this.cervezas = listaDeCervezasConConsumo;
            this.asignarConsumo(parseFloat(key), parseFloat(beerType.consume.toFixed(2)));*/
            for(let i=0; i<resp.length; i++){
              //Reiniciamos los valores
              let consumoTotal1: number = 0;
              consumoTotales = [];
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    // Obtener el nombre de la cerveza y consumo total
                    const beerID = beerType.id;
                    const beerName = beerType.type;
                    consumoTotal1 += beerType.consume;
                    //Consumo total total
                    const consumo = parseFloat(beerType.consume.toFixed(2));
                    //console.log(beerType.consume.toFixed(2).replace('.', ','));
              
                    // Verificar si ya existe la cerveza en consumosTotales
                    const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);
                    const existingBeerIndexTotal = this.consumoTotalesTotalesPorCerveza.findIndex(item => item.type === beerName);

                    if (existingBeerIndexTotal !== -1) {
                      // Actualizar consumo si ya existe la cerveza
                      this.consumoTotalesTotalesPorCerveza[existingBeerIndexTotal].consumo += consumo;
                    } else {
                      // Agregar nueva entrada para la cerveza si no existe
                      this.consumoTotalesTotalesPorCerveza.push({ type: beerName, consumo });
                    }

                    // Poner en la gráfica las cervezas que tienen más de 0 consumo
                    if (existingBeerIndex !== -1) {
                      consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                    } else {  
                      consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                    }
                    
                  }
                }
              }
              if(this.userData.pro_id == 4){
                consumoTotales = consumoTotales.filter(item => item.consumo > 0);
              }
              const consumoTotalRedondeado = consumoTotal1.toFixed(2);
              const establecimientoRanking: RankingEstablecimientos1 = {
                name: resp[i].name,
                consumosTotales: consumoTotales, // copia para evitar referencias directas
                consumoTotal: parseFloat(consumoTotalRedondeado),
              };
              this.rankingData1.push(establecimientoRanking);
            }
            this.rankingData1.sort((a, b) => b.consumoTotal - a.consumoTotal);
            this.topRankingData1 = this.rankingData1.slice(0, 10);
            if(this.userData.pro_id == 4){
              this.consumoTotalesTotalesPorCerveza = this.consumoTotalesTotalesPorCerveza.filter(item => item.consumo > 0);
            }

            //CREAR LA GRÁFICA 
            setTimeout(() => {
              if(this.rankingEstablecimientosDatos){
                const canvasRanking: any = document.getElementById('Ranking');
                const ctxRanking = canvasRanking.getContext('2d');
        
                const labels = [];
                let datasets: any = []; 
                const tiposDeCerveza: any = [];
                for (let j = 0; j < this.topRankingData1.length; j++) {
                  labels.push(this.topRankingData1[j].name);
                  for (let i = 0; i < this.topRankingData1[j].consumosTotales.length; i++) {
                      const cerveza = this.topRankingData1[j].consumosTotales[i];
                      const cervezaInfo = {
                          id: cerveza.id,
                          nombre: cerveza.type
                      };
                      // Verificar si ya hemos agregado esta cerveza por su ID
                      const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
                      if (!existingCerveza) {
                        tiposDeCerveza.push(cervezaInfo);
                      }
                  }
                }
                for(let i=0; i<tiposDeCerveza.length; i++){
                  let data = new Array(this.topRankingData1.length).fill(null); 
                  for(let j=0; j<this.topRankingData1.length; j++){
                    for(let z=0; z<this.topRankingData1[j].consumosTotales.length; z++){
                      const cervezaActual = this.topRankingData1[j].consumosTotales[z];
                      if(cervezaActual.id === tiposDeCerveza[i].id){
                        data[j] = cervezaActual.consumo;
                      }
                    }
                  }
                  datasets.push({
                    label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
                    data: data // Consumo de cada tipo de cerveza
                  })
                }
                const data = {
                  labels: labels,
                  datasets: datasets,
                };

                const soloDosDecimalesConComa = (numero: any) => {
                  return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
                };
                // GRÁFICO RANKING ESTABLECIMIENTOS
                let delayed: any;
                this.chartRanking = new Chart(ctxRanking, {
                  type: 'bar',
                  data: data,
                  options: {
                    animation: {
                      onComplete: () => {
                        delayed = true;
                      },
                      delay: (context) => {
                        let delay = 0;
                        if (context.type === 'data' && context.mode === 'default' && !delayed) {
                          delay = context.dataIndex * 300 + context.datasetIndex * 100;
                        }
                        return delay;
                      },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: "top",
                        labels: {
                          boxWidth: 20,
                          font: {
                            size: 10
                          }
                        }
                      },
                      zoom: {
                        pan: {
                          enabled: true,
                          mode: 'xy',
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          mode: 'xy',
                          onZoomComplete({chart}) {
                            // This update is needed to display up to date zoom level in the title.
                            // Without this, previous zoom level is displayed.
                            // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                            chart.update('none');
                          }
                        },
                      },
                    },
                    interaction: {
                      mode: 'index',
                      intersect: false,
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                        position: 'left',
                        title: {
                          display: true,
                          text: 'Litros',
                          font: {
                            size: 13,
                            weight: 'bold'
                          },
                          padding: {
                            bottom: 20
                          },
                        },
                        stacked: true,
                        ticks: {
                          color: "rgba(0,0,0,0.5)",
                          font: {
                            size: 10,
                            weight: 'bold'
                          },
                          padding: 3,
                          callback: function(value, index, values) {
                            return soloDosDecimalesConComa(value);
                          },
                        },
                        grid: {
                          display: false
                        }
                      },
                      x: {
                        title: {
                          display: true,
                          text: 'Establecimientos',
                          font: {
                            size: 13,
                            weight: 'bold'
                          },
                          padding: {
                            top: 20
                          }
                        },
                        stacked: true,
                        ticks: {
                          padding: 5,
                          color: "rgba(0,0,0,0.5)",
                          font: {
                            size: 10,
                            weight: 'bold'
                          },
                          //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
                        },
                        grid: {
                          display: false
                        }
                      }
                    },
                    elements: {
                      bar: {
                        borderWidth: 2,
                      }
                    }
                  }
                });
                this.charts.push(this.chartRanking);
              }
            },0)
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.rakingEstablecimientosCambiadaCargarda = true;
        }
      });
    } else {
      this.rakingEstablecimientosCambiadaCargarda = true;
      this.rankingEstablecimientosDatos = false;
    }
  }

  cambiarFechaCervezasSemanal(){
    this.semanalEspanaCambiadaCargada = false;
    const startValue = this.selectedDateCervezasSemanal.get('start')?.value;
    const endValue = this.selectedDateCervezasSemanal.get('end')?.value;
    if(startValue != null && endValue != null){
      this.startTopCervezasSemanal = this.convertirFechaInicio(this.selectedDateCervezasSemanal);
      this.endTopCervezasSemanal = this.convertirFechaFin(this.selectedDateCervezasSemanal);
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartRankingCervezas);
      const paises: string [] = [];
      paises.push("España");
      this.rankingDataSemanal = [];
      const establecimientoData1 = new FormData();
      establecimientoData1.append('start', this.startTopCervezasSemanal);
      establecimientoData1.append('end', this.obtenerDiaSiguiente(this.endTopCervezasSemanal));
      establecimientoData1.append('paises', JSON.stringify(paises));
      establecimientoData1.append('desglose', "weeks");
      this.rankingCervezasSubscription = this.deviceService.getEstConsumos(establecimientoData1).subscribe({
        next: resp =>{
          if(resp.length == 0){
            this.semanalDatos = false;
          } else {
            this.semanalDatos = true;
            let consumoTotales: { id: number; type: string; consumo: number }[] = [];
            for(let i=0; i<resp.length; i++){
              //Reiniciamos los valores
              let consumoTotal1: number = 0;
              consumoTotales = [];
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    // Obtener el nombre de la cerveza y consumo total
                    const beerName = beerType.type;
                    const beerID = beerType.id;
                    consumoTotal1 += beerType.consume;
              
                    // Verificar si ya existe la cerveza en consumosTotales
                    const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);

                    if(parseFloat(beerType.consume.toFixed(2)) > 0  && this.userData.pro_id == 4){
                      if (existingBeerIndex !== -1) {
                        consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                      } else {  
                        consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                      }
                    } else {
                      if(this.userData.pro_id !== 4){
                        if (existingBeerIndex !== -1) {
                          consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                        } else {  
                          consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                        }
                      }
                    }
                  }
                }
              }
              const data = {
                week: resp[i].week,
                month: resp[i].month,
                year: resp[i].year
              };
              const consumoTotalRedondeado = consumoTotal1.toFixed(2);
              const establecimientoRanking: any = {
                name: resp[i].name,
                date: this.formatDateSemanaAño(data),
                consumosTotales: consumoTotales, 
                consumoTotal: parseFloat(consumoTotalRedondeado),
              };
              this.rankingDataSemanal.push(establecimientoRanking);
            }
            this.rankingDataSemanal.sort((a, b) => {
              const dateA = a.date;
              const dateB = b.date;
              return dateA.localeCompare(dateB);
            });

            //GRÁFICA CERVEZAS SEMANALMENTE
            setTimeout(() => {
              const canvasRankingCervezas: any = document.getElementById('rankingCervezas');
              const ctxRankingCervezas = canvasRankingCervezas.getContext('2d');

              let labels = [];
              let datasets: any = []; 
              const tiposDeCerveza: any = [];
              for (let j = 0; j < this.rankingDataSemanal.length; j++) {
                labels.push(this.rankingDataSemanal[j].date);
                for (let i = 0; i < this.rankingDataSemanal[j].consumosTotales.length; i++) {
                    const cerveza = this.rankingDataSemanal[j].consumosTotales[i];
                    const cervezaInfo = {
                        id: cerveza.id,
                        nombre: cerveza.type
                    };
                    // Verificar si ya hemos agregado esta cerveza por su ID
                    const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
                    if (!existingCerveza) {
                      tiposDeCerveza.push(cervezaInfo);
                    }
                }
              }
              for(let i=0; i<tiposDeCerveza.length; i++){
                let data = new Array(this.rankingDataSemanal.length).fill(null); 
                for(let j=0; j<this.rankingDataSemanal.length; j++){
                  for(let z=0; z<this.rankingDataSemanal[j].consumosTotales.length; z++){
                    const cervezaActual = this.rankingDataSemanal[j].consumosTotales[z];
                    if(cervezaActual.id === tiposDeCerveza[i].id){
                      data[j] = cervezaActual.consumo;
                    }
                  }
                }
                datasets.push({
                  label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
                  data: data // Consumo de cada tipo de cerveza
                })
              }
              labels = this.filtrarSemanasMismoAnio(labels);
              const data = {
                labels: labels,
                datasets: datasets,
              };

              const soloDosDecimalesConComa = (numero: any) => {
                return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
              };

              let delayed: any;
              const totalDuration = 2000;
              const delayBetweenPoints = totalDuration / data.labels.length;
              const previousY = (ctx: any) => ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y;
              
              const animation = {
                onComplete: () => {
                  // Aquí puedes ejecutar alguna acción después de que se complete la animación, si es necesario.
                },
                x: {
                  type: 'number',
                  easing: 'linear',
                  duration: delayBetweenPoints,
                  from: NaN, // the point is initially skipped
                  delay(ctx: any) {
                    if (ctx.type !== 'data' || ctx.xStarted) {
                      return 0;
                    }
                    ctx.xStarted = true;
                    return ctx.index * delayBetweenPoints;
                  }
                },
                y: {
                  type: 'number',
                  easing: 'linear',
                  duration: delayBetweenPoints,
                  from: previousY,
                  delay(ctx: any) {
                    if (ctx.type !== 'data' || ctx.yStarted) {
                      return 0;
                    }
                    ctx.yStarted = true;
                    return ctx.index * delayBetweenPoints;
                  }
                }
              };
              this.chartRankingCervezas = new Chart(ctxRankingCervezas, {
                type: 'line',
                data: data,
                options: {
                  animation: {
                    onComplete: () => {
                      delayed = true;
                    },
                    delay: (context) => {
                      let delay = 0;
                      if (context.type === 'data' && context.mode === 'default' && !delayed) {
                        delay = context.dataIndex * 30 + context.datasetIndex * 10;
                      }
                      return delay;
                    },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: "top",
                      labels: {
                        boxWidth: 20,
                        font: {
                          size: 10
                        }
                      }
                    },
                    tooltip: {
                      usePointStyle: true,
                      callbacks: {
                        labelPointStyle: function(context) {
                          return {
                              pointStyle: 'rect',
                              rotation: 0,
                          };
                        },
                        label: function(context) {
                          const label = context.dataset.label || '';
                          const value = soloDosDecimalesConComa(context.parsed.y);
                          return `${label}: ${value}`;
                        },
                      }
                    },
                    zoom: {
                      pan: {
                        enabled: true,
                        mode: 'xy',
                      },
                      zoom: {
                        wheel: {
                          enabled: true,
                        },
                        pinch: {
                          enabled: true
                        },
                        mode: 'xy',
                        onZoomComplete({chart}) {
                          // This update is needed to display up to date zoom level in the title.
                          // Without this, previous zoom level is displayed.
                          // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                          chart.update('none');
                        }
                      },
                    },
                  },
                  interaction: {
                    mode: 'index',
                    intersect: false,
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      position: 'left',
                      title: {
                        display: true,
                        text: 'Consumo (Litros)',
                        font: {
                          size: 13,
                          weight: 'bold'
                        },
                        padding: {
                          bottom: 20
                        },
                      },
                      ticks: {
                        color: "rgba(0,0,0,0.5)",
                        font: {
                          size: 10,
                          weight: 'bold'
                        },
                        padding: 3,
                        callback: function(value, index, values) {
                          return soloDosDecimalesConComa(value);
                        },
                      },
                      grid: {
                        display: false
                      }
                    },
                    x: {
                      title: {
                        display: true,
                        text: this.stringFechaConsumoSemanalCervezas,
                        font: {
                          size: 13,
                          weight: 'bold'
                        },
                        padding: {
                          top: 20
                        }
                      },
                      ticks: {
                        padding: 5,
                        color: "rgba(0,0,0,0.5)",
                        font: {
                          size: 10,
                          weight: 'bold'
                        },
                        //autoSkip: false, //Mostrar todo el contenido de las labels en el eje x
                      },
                      grid: {
                        display: false
                      }
                    }
                  }
                }
              });
              this.charts.push(this.chartRankingCervezas);
            },0)
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.semanalEspanaCambiadaCargada = true;
        }
      });
    } else {
      this.semanalEspanaCambiadaCargada = true;
      this.semanalDatos = false;
    }
  }

  cambiarFechaMediaHoras(){
    this.mediaHorasCambiadaCargada = false;
    const startValue = this.selectedDateMediaHoras.get('start')?.value;
    const endValue = this.selectedDateMediaHoras.get('end')?.value;
    if(startValue != null && endValue != null){
      this.startTopMediaHoras = this.convertirFechaInicio(this.selectedDateMediaHoras);
      this.endTopMediaHoras = this.convertirFechaFin(this.selectedDateMediaHoras);
      const startFecha = new Date(this.startTopMediaHoras);
      const endFecha = new Date(this.endTopMediaHoras);
      const diferenciaEnMilisegundos = endFecha.getTime() - startFecha.getTime();
      // Convertir la diferencia a días
      const diferenciaEnDias = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)) +1;
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartMediasHoras);
      this.rankingConsumoPorHora = [];
      const paises1: string [] = []
      paises1.push("España");
      const establecimientoData2 = new FormData();
      establecimientoData2.append('start', this.startTopMediaHoras);
      establecimientoData2.append('end', this.obtenerDiaSiguiente(this.endTopMediaHoras));
      establecimientoData2.append('paises', JSON.stringify(paises1));
      establecimientoData2.append('desglose', "hours");
      this.mediaHorasSubscription = this.deviceService.getEstConsumos(establecimientoData2).subscribe({
        next: resp =>{
          if(resp.length == 0){
            this.mediaHorasDatos = false;
          }
          if(resp.length != 0){
            this.mediaHorasDatos = true;
            const consumoPorHora1: any = [];
            //Inicializar los tipos de cerveza
            for (let hora = 0; hora < 24; hora++) {
              const horaData: any = {};
              for (const key in resp[0].beertypes) {
                if (resp[0].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[0].beertypes[key];
                  if (beerType) {
                    horaData[beerType.type] = 0;
                    horaData["hora"] = hora;
                  }
                }
              }
              consumoPorHora1.push(horaData);
            }
            //Sumar el consumo en cada hora
            for (let i = 0; i < resp.length; i++) {
              const hora = resp[i].hour;
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    consumoPorHora1[hora][beerType.type] += beerType.consume;
                    consumoPorHora1[hora][beerType.type] = parseFloat(consumoPorHora1[hora][beerType.type].toFixed(2));
                  }
                }
              }
            }
            // Calcular la media semanal por hora
            for (let hora = 0; hora < 24; hora++) {
              for (const beerType in consumoPorHora1[hora]) {
                if (consumoPorHora1[hora].hasOwnProperty(beerType)) {
                  if(beerType != "hora"){
                    consumoPorHora1[hora][beerType] /= diferenciaEnDias;
                    consumoPorHora1[hora][beerType] = +consumoPorHora1[hora][beerType].toFixed(2);
                  }
                }
              }
            }
            this.rankingConsumoPorHora = consumoPorHora1;
            //GRÁFICO

            setTimeout(() => {
              const canvasMediasHoras: any = document.getElementById('mediaHoras');
              const ctxMediasHoras = canvasMediasHoras.getContext('2d');

              const labels = []; // Etiquetas para las horas
              const consumosMedioHoras: { label: string, data: number[] }[] = [];
              
              for (let hora = 0; hora < 24; hora++) {
                const horaFormateada = hora.toString().padStart(2, '0');
                labels.push(`${horaFormateada}:00`);
              
                const datosHora = this.rankingConsumoPorHora[hora];
                if (datosHora) {
                  for (const tipoCerveza in datosHora) {
                    if (datosHora.hasOwnProperty(tipoCerveza)) {
                      const consumo = datosHora[tipoCerveza];
                      // Buscar la posición del tipo de cerveza en consumosMedioHoras
                      const index = consumosMedioHoras.findIndex(item => item.label === tipoCerveza);
                      if (index !== -1) {
                        // Si ya existe, agregar el consumo a la lista existente
                        consumosMedioHoras[index].data.push(consumo);
                      } else {
                        // Si no existe, agregar un nuevo elemento a consumosMedioHoras
                        consumosMedioHoras.push({ label: tipoCerveza, data: [consumo] });
                      }
                    }
                  }
                }
              }
              let datasetsConsumosMediosHoras = [];
              for (const consumoMedio of consumosMedioHoras) {
                if (consumoMedio.label !== "hora") {
                  // Verificar si todos los consumos son 0
                  const allZero = consumoMedio.data.every(value => value === 0);
                  if (!allZero) {
                    // Reemplazar 0 por null en consumoMedio.data
                    const newData = consumoMedio.data.map(value => value === 0 ? null : value);
                    datasetsConsumosMediosHoras.push({
                      label: consumoMedio.label,
                      data: newData,
                      borderWidth: 2,
                      pointBorderWidth: 1,
                      pointHoverRadius: 10,
                      pointHoverBorderWidth: 1,
                      pointRadius: 5,
                      fill: true,
                      yAxisID: 'y',
                      pointBorderColor: '#fff',
                    });
                  }
                }
              }
              const data = {
                labels: labels,
                datasets: datasetsConsumosMediosHoras
              };

              const soloDosDecimalesConComa = (numero: any) => {
                return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
              };
              
              let delayed: any;
              this.chartMediasHoras = new Chart(ctxMediasHoras, {
                type: 'radar',
                data: data,
                options: {
                  animation: {
                    onComplete: () => {
                      delayed = true;
                    },
                    delay: (context) => {
                      let delay = 0;
                      if (context.type === 'data' && context.mode === 'default' && !delayed) {
                        delay = context.dataIndex * 30 + context.datasetIndex * 10;
                      }
                      return delay;
                    },
                  },
                  plugins: {
                    tooltip: {
                      callbacks: {
                        label: function(context) {
                          const label = context.dataset.label || '';
                          const value = soloDosDecimalesConComa(context.parsed.r);
                          return `${label}: ${value}`;
                        },
                      },
                    },
                  },
                  elements: {
                    line: {
                      borderWidth: 3
                    }
                  },
                  scales: {
                    r: {
                      angleLines: {
                        display: false
                      },
                      beginAtZero: true,
                      pointLabels: {
                        font: {
                          size: 12,
                        },
                      },
                      ticks: {
                        callback: function (value) {
                          return value + ' L';
                        },
                        padding: 15
                      },
                      suggestedMin: 0,
                    }
                  }
                },
              });
              this.charts.push(this.chartMediasHoras);
            },0)
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.mediaHorasCambiadaCargada = true;
        },
      });
    } else {
      this.mediaHorasCambiadaCargada = true;
      this.mediaHorasDatos = false;
    }
  }

  cambiarFechaDiario(){
    this.diarioCambiadaCargada = false;
    const startValue = this.selectedDateDiario.get('start')?.value;
    const endValue = this.selectedDateDiario.get('end')?.value;
    if(startValue != null && endValue != null){
      this.startTopDiario = this.convertirFechaInicio(this.selectedDateDiario);
      this.endTopDiario = this.convertirFechaFin(this.selectedDateDiario);
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartDiarioSemana);
      this.rankingDataDiario = [];
      const paises2: string [] = []
      paises2.push("España");
      const establecimientoData3 = new FormData();
      establecimientoData3.append('start', this.startTopDiario);
      establecimientoData3.append('end', this.obtenerDiaSiguiente(this.endTopDiario));
      establecimientoData3.append('paises', JSON.stringify(paises2));
      establecimientoData3.append('desglose', "days");
      this.diasCervezaSubscription = this.deviceService.getEstConsumos(establecimientoData3).subscribe({
        next: resp =>{
          console.log(resp);
          if(resp.length == 0){
            this.diarioDatos = false;
            this.diarioCambiadaCargada = true;
          } else {
            this.diarioDatos = true;
            let consumoTotales: { id: number; type: string; consumo: number }[] = [];
            for(let i=0; i<resp.length; i++){
              //Reiniciamos los valores
              let consumoTotal1: number = 0;
              consumoTotales = [];
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    // Obtener el nombre de la cerveza y consumo total
                    const beerName = beerType.type;
                    consumoTotal1 += beerType.consume;
                    const beerID = beerType.id;
                    const consumo = parseFloat(beerType.consume.toFixed(2));
              
                    // Verificar si ya existe la cerveza en consumosTotales
                    const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);

                    if(parseFloat(beerType.consume.toFixed(2)) > 0  && this.userData.pro_id == 4){
                      if (existingBeerIndex !== -1) {
                        consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                      } else {  
                        consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                      }
                    } else {
                      if(this.userData.pro_id !== 4){
                        if (existingBeerIndex !== -1) {
                          consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                        } else {  
                          consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                        }
                      }
                    }
                  }
                }
              }
              const data = {
                day: resp[i].day,
                month: resp[i].month,
                year: resp[i].year
              };
              const consumoTotalRedondeado = consumoTotal1.toFixed(2);
              const establecimientoRanking: any = {
                name: resp[i].name,
                date: this.formatDateDiaMesAño(data),
                consumosTotales: consumoTotales, // copia para evitar referencias directas
                consumoTotal: parseFloat(consumoTotalRedondeado),
              };
              this.rankingDataDiario.push(establecimientoRanking);
            }
            this.rankingDataDiario.sort((a, b) => {
              const dateA = a.date;
              const dateB = b.date;
              return dateA.localeCompare(dateB);
            });

            const soloDosDecimalesConComa = (numero: any) => {
              return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
            };
            //GRAFICO
            setTimeout(() => {
              if(this.diarioDatos){
                const canvasConsumoDiarioSemanal: any = document.getElementById('cervezasDiario');
                const ctxConsumoDiarioSemanal = canvasConsumoDiarioSemanal.getContext('2d');
        
                let labels = [];
                let datasets: any = []; 
                const tiposDeCerveza: any = [];
                for (let j = 0; j < this.rankingDataDiario.length; j++) {
                  labels.push(this.rankingDataDiario[j].date);
                  for (let i = 0; i < this.rankingDataDiario[j].consumosTotales.length; i++) {
                      const cerveza = this.rankingDataDiario[j].consumosTotales[i];
                      const cervezaInfo = {
                          id: cerveza.id,
                          nombre: cerveza.type
                      };
                      // Verificar si ya hemos agregado esta cerveza por su ID
                      const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
                      if (!existingCerveza) {
                        tiposDeCerveza.push(cervezaInfo);
                      }
                  }
                }
                for(let i=0; i<tiposDeCerveza.length; i++){
                  let data = new Array(this.rankingDataDiario.length).fill(null); 
                  for(let j=0; j<this.rankingDataDiario.length; j++){
                    for(let z=0; z<this.rankingDataDiario[j].consumosTotales.length; z++){
                      const cervezaActual = this.rankingDataDiario[j].consumosTotales[z];
                      if(cervezaActual.id === tiposDeCerveza[i].id){
                        data[j] = cervezaActual.consumo;
                      }
                    }
                  }
                  // Índice circular en backgroundColorsOpacos
                  const indexColor = i % this.backgroundColorsOpacos.length;
                  datasets.push({
                    label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
                    data: data, // Consumo de cada tipo de cerveza
                    fill: true,
                    backgroundColor: this.backgroundColorsOpacos[indexColor],
                    borderColor: this.borderColor[indexColor],
                    borderWidth: 2,
                    pointBorderWidth: 1,
                    pointHoverRadius: 10,
                    pointHoverBorderWidth: 1,
                    pointRadius: 5,
                  })
                }
                const compararFechas = (fechaA: any, fechaB: any) => {
                  const dateA: any = new Date(fechaA.split('/').reverse().join('/'));
                  const dateB: any = new Date(fechaB.split('/').reverse().join('/'));
                  return dateA - dateB;
                };
                labels = labels.sort(compararFechas);
                labels = this.filtrarFechasMismoMesAnio(labels);
                const data = {
                  labels: labels,
                  datasets: datasets,
                };
                
                // GRÁFICO DIARIO SEMANAL
                this.chartDiarioSemana = new Chart(ctxConsumoDiarioSemanal, {
                  type: 'line',
                  data: data,
                  options: {
                    animation: {
                      duration: 1000,
                      easing: 'easeInOutQuad',
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      tooltip: {
                        usePointStyle: true,
                        callbacks: {
                          labelPointStyle: function(context) {
                            return {
                                pointStyle: 'rect',
                                rotation: 0,
                            };
                          },
                          label: function(context) {
                            const label = context.dataset.label || '';
                            const value = soloDosDecimalesConComa(context.parsed.y);
                            return `${label}: ${value}`;
                          },
                        }
                      },
                      legend: {
                        position: "top",
                        labels: {
                          boxWidth: 20,
                          font: {
                            size: 10
                          }
                        }
                      },
                      zoom: {
                        pan: {
                          enabled: true,
                          mode: 'xy',
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          mode: 'xy',
                          onZoomComplete({chart}) {
                            // This update is needed to display up to date zoom level in the title.
                            // Without this, previous zoom level is displayed.
                            // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                            chart.update('none');
                          }
                        },
                      },
                    },
                    interaction: {
                      mode: 'index',
                      intersect: false,
                    },
                    scales: {
                      y: {
                        stacked: true,
                        beginAtZero: true,
                        position: 'left',
                        title: {
                          display: true,
                          text: 'Consumo (Litros)',
                          font: {
                            size: 13,
                            weight: 'bold'
                          },
                          padding: {
                            bottom: 20
                          },
                        },
                        ticks: {
                          color: "rgba(0,0,0,0.5)",
                          font: {
                            size: 10,
                            weight: 'bold'
                          },
                          padding: 3,
                          callback: function(value, index, values) {
                            return soloDosDecimalesConComa(value);
                          },
                        },
                        grid: {
                          display: false
                        },
                      },
                      x: {
                        stacked: true,
                        title: {
                          display: true,
                          text: this.stringFechaConsumoDiarioEspaña,
                          font: {
                            size: 13,
                            weight: 'bold'
                          },
                          padding: {
                            top: 20
                          }
                        },
                        ticks: {
                          padding: 5,
                          color: "rgba(0,0,0,0.5)",
                          font: {
                            size: 10,
                            weight: 'bold'
                          },
                          //autoSkip: false, //Mostrar todo el contenido de las labels en el eje x
                        },
                        grid: {
                          display: false
                        }
                      }
                    }
                  }
                });
                this.charts.push(this.chartDiarioSemana);
              }
            },0)
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.diarioCambiadaCargada = true;
        }
      });
    } else {
      this.diarioCambiadaCargada = true;
      this.diarioDatos = false;
    }
  }

  cambiarFechaMediaEstProvincia(){
    this.provinciasCambiadaCargada = false;
    const startValue = this.selectedDateMediaEstProvincia.get('start')?.value;
    const endValue = this.selectedDateMediaEstProvincia.get('end')?.value;
    if(startValue != null && endValue != null){
      this.startTopMediaEstProvincia = this.convertirFechaInicio(this.selectedDateMediaEstProvincia);
      this.endTopMediaEstProvincia = this.convertirFechaFin(this.selectedDateMediaEstProvincia);
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartProvinciasEstablecimientos);
      const nombresProvincias = this.provincias.map(provincia => provincia.name);
      this.consumosPorProvincia = [];
      this.establecimientosPorProvincia = [];
      this.rankingDataProvincias = [];
      this.topRankingDataProvincias = [];
      const establecimientoData4 = new FormData();
      establecimientoData4.append('start', this.startTopMediaEstProvincia);
      establecimientoData4.append('end', this.obtenerDiaSiguiente(this.endTopMediaEstProvincia));
      establecimientoData4.append('provincias', JSON.stringify(nombresProvincias));
      establecimientoData4.append('desglose', "total");
      this.rankingCervezasSubscription = this.deviceService.getEstConsumos(establecimientoData4).subscribe({
        next: resp =>{
          if(resp.length == 0){
            this.provinciasDatos = false;
          } else {
            this.provinciasDatos = true;
            this.consumosPorProvincia = resp;
            // Filtrar los establecimientos por provincia
            for (let i = 0; i < resp.length; i++) {
              const establecimientosProvinciaActual = this.establecimientosData.filter((establecimiento: { localidad: { administrative_area_level_2: string } }) => {
                return resp[i].name.includes(establecimiento.localidad.administrative_area_level_2);
              });
              this.establecimientosPorProvincia.push({
                provincia: resp[i].name,
                establecimientos: establecimientosProvinciaActual,
              });
            }
            //Suma total de todos los establecimientos
            let consumoTotales: { type: string; consumo: number}[] = [];
            for(let i=0; i<resp.length; i++){
              //Reiniciamos los valores
              let consumoTotal1: number = 0;
              consumoTotales = [];
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    // Obtener el nombre de la cerveza y consumo total
                    const beerName = beerType.type;
                    consumoTotal1 += beerType.consume;
              
                    // Verificar si ya existe la cerveza en consumosTotales
                    const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);

                    if (existingBeerIndex !== -1) {
                      consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                    } else {  
                      consumoTotales.push({ type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                    }
                  }
                }
              }
              for(let j=0; j<this.establecimientosPorProvincia.length; j++){
                if(this.consumosPorProvincia[i].name == this.establecimientosPorProvincia[j].provincia){
                  const consumoTotalRedondeado = consumoTotal1.toFixed(2);
                  const establecimientoRanking: RankingProvincias = {
                    name: resp[i].name,
                    nEstablecimientos: this.establecimientosPorProvincia[j].establecimientos.length,
                    consumosTotales: { ...consumoTotales }, // copia para evitar referencias directas
                    consumoMedioEstablecimiento: parseFloat((parseFloat(consumoTotalRedondeado)/this.establecimientosPorProvincia[j].establecimientos.length).toFixed(2)),
                    consumoTotal: parseFloat(consumoTotalRedondeado),
                  };
                  this.rankingDataProvincias.push(establecimientoRanking);
                }
              }
            }
            this.rankingDataProvincias.sort((a, b) => b.consumoMedioEstablecimiento - a.consumoMedioEstablecimiento);
            this.topRankingDataProvincias = this.rankingDataProvincias.slice(0, 5);
            console.log(this.topRankingDataProvincias);
            const elementosRestantes1 = this.rankingDataProvincias.slice(5);

            if(elementosRestantes1.length !== 0){
              // Calcular consumo medio de los establecimientos restantes
              let totalEstablecimientosRestantes = 0;
              let totalConsumoRestantes = 0;
              for (const establecimiento of elementosRestantes1) {
                totalEstablecimientosRestantes += establecimiento.nEstablecimientos;
                totalConsumoRestantes += establecimiento.consumoTotal;
              }
              const consumoMedioEstablecimientosRestantes = totalConsumoRestantes / totalEstablecimientosRestantes;
              const establecimientoRestantes: RankingProvincias = {
                name: 'Restantes',
                nEstablecimientos: totalEstablecimientosRestantes,
                consumosTotales: [], // Puedes ajustar esto según tu estructura
                consumoMedioEstablecimiento: consumoMedioEstablecimientosRestantes,
                consumoTotal: totalConsumoRestantes,
              };
              const listaFinal = this.topRankingDataProvincias.concat([establecimientoRestantes]);
              this.topRankingDataProvincias = listaFinal;
            }
            //GRÁFICA
            setTimeout(() => {
              const canvasProvinciasConsumo: any = document.getElementById('provinciasConsumo');
              const ctxProvinciasConsumo = canvasProvinciasConsumo.getContext('2d');

              let namesRankingProvincias = [];
              let consumoMedioRankingProvincias = [];
              for (const provincia of this.topRankingDataProvincias) {
                //Guradar los nombres de las provincias y los consumos
                namesRankingProvincias.push(provincia.name);
                consumoMedioRankingProvincias.push(provincia.consumoMedioEstablecimiento);
              }
              let datasetsConsumosProvinciaEstablecimientos = [];
              datasetsConsumosProvinciaEstablecimientos.push({
                label: "Consumo Medio ",
                data: consumoMedioRankingProvincias,
                borderWidth: 1,
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: true,
                yAxisID: 'y',
                backgroundColor: 'rgba(237, 177, 12, 0.2)',
                borderColor: 'rgb(237, 177, 12)', 
                pointBackgroundColor: 'rgb(237, 177, 12)', 
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(237, 177, 12)'
              });

              const soloDosDecimalesConComa = (numero: any) => {
                return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
              };

              this.chartProvinciasEstablecimientos = new Chart(ctxProvinciasConsumo, {
                type: 'bar',
                data: {
                  labels: namesRankingProvincias,
                  datasets: datasetsConsumosProvinciaEstablecimientos
                },
                options: {
                  indexAxis: 'y',
                  elements: {
                    bar: {
                      borderWidth: 2,
                    }
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    tooltip: {
                      callbacks: {
                        label: function(context) {
                          const label = context.dataset.label || '';
                          const value = soloDosDecimalesConComa(context.parsed.x);
                          return `${label}: ${value}`;
                        },
                      }
                    },
                    zoom: {
                      pan: {
                        enabled: true,
                        mode: 'xy',
                      },
                      zoom: {
                        wheel: {
                          enabled: true,
                        },
                        pinch: {
                          enabled: true
                        },
                        mode: 'xy',
                        onZoomComplete({chart}) {
                          // This update is needed to display up to date zoom level in the title.
                          // Without this, previous zoom level is displayed.
                          // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                          chart.update('none');
                        }
                      },
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      position: 'left',
                      ticks: {
                        color: "rgba(0,0,0,0.5)",
                        font: {
                          size: 10,
                          weight: 'bold'
                        },
                        padding: 3,
                      },
                      grid: {
                        display: false
                      }
                    },
                    x: {
                      title: {
                        display: true,
                        text: 'Litros',
                        font: {
                          size: 13,
                          weight: 'bold'
                        },
                        padding: {
                          top: 20
                        }
                      },
                      ticks: {
                        padding: 5,
                        color: "rgba(0,0,0,0.5)",
                        font: {
                          size: 10,
                          weight: 'bold'
                        },
                        callback: function(value, index, values) {
                          return soloDosDecimalesConComa(value);
                        },
                        //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
                      },
                      grid: {
                        display: false
                      }
                    }
                  }
                }
              });
              this.charts.push(this.chartProvinciasEstablecimientos);
            },0)
          }
        }, error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.provinciasCambiadaCargada = true;
        }
      });
    } else {
      this.provinciasCambiadaCargada = true;
      this.provinciasDatos = false;
    }
  }

  eliminarFilasDuplicadas(arr: any) {
    const uniqueData = new Set(); // Usamos un conjunto (Set) para almacenar las fechas únicas.
    const result = [];
    for (const item of arr) {
      if (!uniqueData.has(item.data)) {
        // Si la fecha no está en el conjunto, la añadimos al resultado y al conjunto.
        uniqueData.add(item.data);
        result.push(item);
      }
    }
    return result;
  }

  obtenerFechaAñoAnterior(fechaStr: string) {
    const partesFecha = fechaStr.split('-');
    if (partesFecha.length !== 3) {
      throw new Error('Formato de fecha no válido');
    }
    const dia = parseInt(partesFecha[0], 10);
    const mes = parseInt(partesFecha[1], 10) - 1;
    const año = parseInt(partesFecha[2], 10);
    const fecha = new Date(año, mes, dia);
    fecha.setFullYear(año - 1);
    return fecha;
  }

  convertirFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    return `${año}-${mes}-${dia}`;
  }

  //FUNCIONES PARA ELIMINAR DUPLICADOS
    eliminarDuplicadosPaises(arr: Paises[]): Paises[] {
      const uniqueSet = new Set(arr.map(paises => paises.name));
      const uniqueNames = Array.from(uniqueSet);
      // Convertir los nombres únicos nuevamente a objetos Provincia
      const uniquePaises: Paises[] = uniqueNames.map(name => ({ name }));
      return uniquePaises;
    }

    eliminarDuplicadosComunidades(arr: Comunidades[]): Comunidades[] {
      const uniqueMap = new Map<string, Comunidades>();
      // Iterar sobre el arreglo original y agregar las localidades al mapa
      for (const comunidad of arr) {
        const key = `${comunidad.name}-${comunidad.pais}`;
        uniqueMap.set(key, comunidad);
      }
      // Convertir el mapa de nuevo a un arreglo
      const uniqueLocalidades: Comunidades[] = Array.from(uniqueMap.values());
      return uniqueLocalidades;
    }

    /*eliminarDuplicadosProvincias(arr: Provincias[]): Provincias[] {
      const uniqueSet = new Set(arr.map(provincia => provincia.name));
      const uniqueNames = Array.from(uniqueSet);
      // Convertir los nombres únicos nuevamente a objetos Provincia
      const uniqueProvincias: Provincias[] = uniqueNames.map(name => ({ name }));
      return uniqueProvincias;
    }*/

    eliminarDuplicadosProvincias(arr: Provincias[]): Provincias[] {
      const uniqueMap = new Map<string, Provincias>();
      // Iterar sobre el arreglo original y agregar las localidades al mapa
      for (const provincia of arr) {
        const key = `${provincia.name}-${provincia.comunidad}-${provincia.pais}`;
        uniqueMap.set(key, provincia);
      }
      // Convertir el mapa de nuevo a un arreglo
      const uniqueLocalidades: Provincias[] = Array.from(uniqueMap.values());
      return uniqueLocalidades;
    }

    /*eliminarDuplicadosLocalidades(arr: Localidades[]): Localidades[] {
      const uniqueSet = new Set(arr.map(localidades => localidades.name));
      const uniqueNames = Array.from(uniqueSet);
      // Convertir los nombres únicos nuevamente a objetos Provincia
      const uniqueLocalidades: Localidades[] = uniqueNames.map(name => ({ name }));
      return uniqueLocalidades;
    }*/

    eliminarDuplicadosLocalidades(arr: Localidades[]): Localidades[] {
      const uniqueMap = new Map<string, Localidades>();
      // Iterar sobre el arreglo original y agregar las localidades al mapa
      for (const localidad of arr) {
        const key = `${localidad.id}`;
        uniqueMap.set(key, localidad);
      }
      // Convertir el mapa de nuevo a un arreglo
      const uniqueLocalidades: Localidades[] = Array.from(uniqueMap.values());
      return uniqueLocalidades;
    }

    eliminarElementosRepetidos(lista: number[]): number[] {
      const conjunto = new Set<number>();
      for (const elemento of lista) {
        conjunto.add(elemento);
      }
      const listaSinRepetidos = Array.from(conjunto);
      return listaSinRepetidos;
    }


  //VARIABLES CAMBIADAS
    seleccionCambiada(){
      //Si no hay ningún filtro se devuelven todos los establecimientos
      //FILTRAR POR COMUNIDADES
      this.ubicacionSeleccionada = "";
      if(this.selectedPaises.length !== 0){
        this.comunidades = this.comunidadesOriginal;
        this.filtrarComunidades();
      } else{
        this.comunidades = this.comunidadesOriginal;
      }
      //FILTRAR PROVINCIAS
      if(this.selectedComunidades.length !== 0 || this.selectedPaises.length !== 0){
        this.provincias = this.provinciasOriginal;
        this.filtrarProvincias();
      } else{
        this.provincias = this.provinciasOriginal;
      }
      //FILTRAR LOCALIDADES
      if(this.selectedProvincias.length !== 0 || this.selectedComunidades.length !== 0 || this.selectedPaises.length !== 0){
        this.localidades = this.localidadesOriginal;
        this.filtrarLocalidades();
      } else{
        this.localidades = this.localidadesOriginal;
      }
      //FILTRAR LOS SELECCIONADOS DEPENDIENDO DE SI ESTÁN EN LA LISTA O NO DESPUÉS DE FILTRARSE
        //Comunidades
        const comunidadesSeleccionadas = this.comunidades.filter(comunidad => {
          return this.selectedComunidades.includes(comunidad.name);
        });
        this.selectedComunidades = comunidadesSeleccionadas.map(comunidad => comunidad.name);
        //Provincias
        const provinciasSeleccionadas = this.provincias.filter(provincia => {
          return this.selectedProvincias.includes(provincia.name);
        });
        this.selectedProvincias = provinciasSeleccionadas.map(provincia => provincia.name);
        //Localidades
        const localidadesSeleccionadas = this.localidades.filter(localidad => {
          return this.selectedLocalidades.includes(localidad.id);
        });
        this.selectedLocalidades = localidadesSeleccionadas.map(localidad => localidad.id);
      
      //UNA VEZ FILTRADOS SE PUEDEN ELEGIR QUE ESTABLECIMIENTOS SE ENSEÑAN
        if(
          (this.selectedCervezas == undefined || (Array.isArray(this.selectedCervezas) && this.selectedCervezas.length === 0)) && 
          (this.selectedLocalidades == undefined || (Array.isArray(this.selectedLocalidades) && this.selectedLocalidades.length === 0)) && 
          (this.selectedProvincias == undefined || (Array.isArray(this.selectedProvincias) && this.selectedProvincias.length === 0)) &&
          (this.selectedComunidades == undefined || (Array.isArray(this.selectedComunidades) && this.selectedComunidades.length === 0)) && 
          (this.selectedPaises == undefined || (Array.isArray(this.selectedPaises) && this.selectedPaises.length === 0))){
            this.establecimientosCopia = this.establecimientos;
            console.log(this.establecimientosCopia);
        } else {
          this.establecimientosCopia = [];
          const establecimientoIdFiltradosCervezas = this.devolverEstablecimientosCerveza(this.selectedCervezas);
          const establecimientoIdFiltradosLocalidades = this.devolverEstablecimientosLocalidades(this.selectedLocalidades);
          const establecimientoIdFiltradosProvincias = this.devolverEstablecimientos('administrative_area_level_2', this.selectedProvincias);
          const establecimientoIdFiltradosComunidades = this.devolverEstablecimientos('administrative_area_level_1', this.selectedComunidades);
          const establecimientoIdFiltradosPais = this.devolverEstablecimientos('country', this.selectedPaises);
          //const establecimientoIdFiltradosLocalidades = this.devolverEstablecimientosLocalidades(this.selectedLocalidades);
          //const establecimientoIdFiltradosProvincias = this.devolverEstablecimientosProvincia(this.selectedProvincias);
          /*console.log("Cervezas",establecimientoIdFiltradosCervezas);
          console.log("Localidades",establecimientoIdFiltradosLocalidades);
          console.log("Provincias",establecimientoIdFiltradosProvincias);
          console.log("Comunidades",establecimientoIdFiltradosComunidades);
          console.log("Paises",establecimientoIdFiltradosPais);*/
          //La ubicación no es excluyente
          //const numerosUnicos = [...new Set(establecimientoIdFiltradosLocalidades.concat(establecimientoIdFiltradosProvincias, establecimientoIdFiltradosComunidades, establecimientoIdFiltradosPais))];
          //console.log("Establecimientos que tienen alguna ubicación",numerosUnicos);
          let numerosUnicos: number[] = [];
          if(establecimientoIdFiltradosLocalidades.length != 0){
            numerosUnicos = establecimientoIdFiltradosLocalidades;
            this.ubicacionSeleccionada = "Localidad";
          }
          if(establecimientoIdFiltradosLocalidades.length == 0 && establecimientoIdFiltradosProvincias.length != 0){
            numerosUnicos = establecimientoIdFiltradosProvincias;
            this.ubicacionSeleccionada = "Provincia";
          }
          if(establecimientoIdFiltradosLocalidades.length == 0 && establecimientoIdFiltradosProvincias.length == 0 &&
            establecimientoIdFiltradosComunidades.length != 0){
            numerosUnicos = establecimientoIdFiltradosComunidades;
            this.ubicacionSeleccionada = "Comunidad";
          }
          if(establecimientoIdFiltradosLocalidades.length == 0 && establecimientoIdFiltradosProvincias.length == 0 &&
            establecimientoIdFiltradosComunidades.length == 0 && establecimientoIdFiltradosPais.length != 0){
            numerosUnicos = establecimientoIdFiltradosPais;
            this.ubicacionSeleccionada = "País";
          }
          const establecimientosRepetidos = this.obtenerNumerosRepetidosMultiple(establecimientoIdFiltradosCervezas, numerosUnicos);
          //console.log("Establecimientos que tienen alguna ubicación y tienen el tipo de cerveza",establecimientosRepetidos);
          for(let i=0; i<establecimientosRepetidos.length; i++){
            for(let j=0; j<this.establecimientosData.length; j++){
              if(establecimientosRepetidos[i]==this.establecimientosData[j].id){
                this.establecimientosCopia.push({
                  value: this.establecimientosData[j].id,
                  name: this.establecimientosData[j].est_name
                });
              }
            }
          }
        }
      this.ordenarEstablecimientosCopia();
    }

    obtenerNumerosRepetidosMultiple(...listas: number[][]) {
      const listasNoVacias = listas.filter(lista => lista.length > 0);
      if (listasNoVacias.length === 0) {
        return [];
      }
      const setListas = listasNoVacias.map(lista => new Set(lista));
      const numerosRepetidos = [];
      for (const numero of listasNoVacias[0]) {
        if (setListas.every(setLista => setLista.has(numero))) {
          numerosRepetidos.push(numero);
        }
      }
      if (numerosRepetidos.length === 0) {
        return listasNoVacias[0].filter(numero => {
          return listasNoVacias.slice(1).every(lista => lista.includes(numero));
        });
      }
      return numerosRepetidos;
    }

    obtenerNumerosRepetidos(lista1: any, lista2 :any) {
      if (lista1.length === 0 || lista2.length === 0) {
        return lista1.length === 0 ? lista2 : lista1;
      }
      const setLista1 = new Set(lista1);
      const numerosRepetidos = [];
      for (const numero of lista2) {
        if (setLista1.has(numero)) {
          numerosRepetidos.push(numero);
        }
      }
      return numerosRepetidos;
    }

    //Función paar devolver los datos de un establecimiento
    devolverEstablecimiento(establecimientoId: number){
      const establecimiento = this.establecimientosData.find((establecimiento: any) => establecimiento.id == establecimientoId)
      return establecimiento
    }

    //Función para devolver los establecimientos que cumplen el filtro de ubicación
    devolverEstablecimientos(propiedad: string, valoresSeleccionados: any): number[] {
      const establecimientosIds: number[] = [];
      if (Array.isArray(valoresSeleccionados)) {
        for (let i = 0; i < this.establecimientosData.length; i++) {
          if (this.establecimientosData[i].localidad !== null && this.establecimientosData[i].localidad[propiedad] !== null) {
            const valor = this.establecimientosData[i].localidad[propiedad];
            if (valoresSeleccionados.includes(valor)) {
              establecimientosIds.push(this.establecimientosData[i].id);
            }
          }
        }
      }
      return establecimientosIds;
    }

    //Para localidades es distinto porque tengo que pasarle dos propiedades
    devolverEstablecimientosLocalidades(valoresSeleccionados: any[]): number[] {
      const establecimientosIds: number[] = [];
      if (Array.isArray(valoresSeleccionados)) {
        for (let i = 0; i < this.establecimientosData.length; i++) {
          if (this.establecimientosData[i].localidad_id !== null) {
            const valor1 = this.establecimientosData[i].localidad_id;
            if (valoresSeleccionados.some(selected => selected === valor1)) {
              establecimientosIds.push(this.establecimientosData[i].id);
            }
          }
        }
      }
      return establecimientosIds;
    }

    devolverEstablecimientosCerveza(cervezasSeleccionadas: any): number[]{
      const establecimientosIds: number[] = [];
      if (Array.isArray(cervezasSeleccionadas)) {
        for (let i = 0; i < this.establecimientosData.length; i++) {
          const numeros = this.establecimientosData[i].est_beertypes
            .slice(1, -1)
            .split(",")
            .map(Number);

          const todosIguales = cervezasSeleccionadas.some(selectedCerveza =>
            numeros.includes(selectedCerveza)
          );
    
          if (todosIguales) {
            establecimientosIds.push(this.establecimientosData[i].id);
          }
        }
      }
      return establecimientosIds;
    }

  ngOnDestroy(): void {
    if (this.usersSubscription) {
      this.usersSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.resultadoSubscription) {
      this.resultadoSubscription.unsubscribe();
    } 
    if (this.rankingSubscription) {
      this.rankingSubscription.unsubscribe();
    } 
    if (this.rankingCervezasSubscription) {
      this.rankingCervezasSubscription.unsubscribe();
    } 
    if (this.mediaHorasSubscription) {
      this.mediaHorasSubscription.unsubscribe();
    } 
    if (this.diasCervezaSubscription) {
      this.diasCervezaSubscription.unsubscribe();
    } 
    if (this.tablaBusquedaSubscription) {
      this.tablaBusquedaSubscription.unsubscribe();
    } 
    if (this.crearBusquedaSubscription) {
      this.crearBusquedaSubscription.unsubscribe();
    } 
    if (this.eliminarBusquedaSubscription){
      this.eliminarBusquedaSubscription.unsubscribe();
    }
    if (this.historicoDiaSubscription){
      this.historicoDiaSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  convertirFechaInicio(selectedDate: FormGroup): string {
    if (selectedDate.value.start) {
      const fecha = new Date(selectedDate.value.start);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha Inicio no seleccionada";
  }

  convertirFechaFin(selectedDate: FormGroup): string {
    if (selectedDate.value.end) {
      const fecha = new Date(selectedDate.value.end);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha Fin no seleccionada";
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const searchTerms = filter.split(' ');
      return searchTerms.every(term => this.customFilterPredicate(data, term));
    };
  }

  customFilterPredicate(data: any, filter: string): boolean {
    const dataStr = JSON.stringify(data).toLowerCase();
    const searchStr = filter.toLowerCase();
    return dataStr.indexOf(searchStr) !== -1;
  }

  //FUNCIONES PARA SELECCIONAR TODOS LOS ELEMENTOS
    selectAllEstablecimientosChanged() {
      if (this.selectAllEstablecimientos) {
        this.selectedEstablecimiento = this.establecimientosCopia.map(establecimiento => establecimiento.value);
      } else {
        this.selectedEstablecimiento = [];
      }
    }

    selectAllCervezasChanged() {
      if (this.selectAllCervezas) {
        this.selectedCervezas = this.cervezasEstadisticas.map(cerveza => cerveza.value);
      } else {
        this.selectedCervezas = [];
      }
    }

    selectAllLocalidadesChanged() {
      if (this.selectAllLocalidades) {
        this.selectedLocalidades = this.localidades.map(localidad => localidad.id);
        //this.ubicacionSeleccionada = "Localidad";
        this.seleccionCambiada();
      } else {
        this.selectedLocalidades = [];
        this.seleccionCambiada();
      }
    }

    selectAllProvinciasChanged() {
      if (this.selectAllProvincias) {
        this.selectedProvincias = this.provincias.map(provincia => provincia.name);
        //this.ubicacionSeleccionada = "Provincia";
        this.seleccionCambiada();
      } else {
        this.selectedProvincias = [];
        this.seleccionCambiada();
      }
    }

    selectAllComunidadesChanged() {
      if (this.selectAllComunidades) {
        this.selectedComunidades = this.comunidades.map(comunidad => comunidad.name);
        //this.ubicacionSeleccionada = "Comunidad";
        this.seleccionCambiada();
      } else {
        this.selectedComunidades = [];
        this.seleccionCambiada();
      }
    }

    selectAllPaisesChanged() {
      if (this.selectAllPaises) {
        this.selectedPaises = this.paises.map(pais => pais.name);
        //this.ubicacionSeleccionada = "País";
        this.seleccionCambiada();
      } else {
        this.selectedPaises = [];
        this.seleccionCambiada();
      }
    }

  //Le pasas el id del establecimiento y te devuelve su nombre
  devolverNombreEstablecimientos(estId: number){
    for (let i=0; i<this.establecimientosData.length; i++){
      if (this.establecimientosData[i].id == estId){
        return this.establecimientosData[i].est_name;
      }
    }
  }

  existeSelected2(selected: string[]){
    if(selected == undefined || (Array.isArray(selected) && selected.length === 0)){
      return false;
    } else {
      return true;
    }
  }

  existeSelected(selected: number []){
    if(selected == undefined || (Array.isArray(selected) && selected.length === 0)){
      return false;
    } else {
      return true;
    }
  }

  existeSelected1(selected: number | undefined){
    if(selected == undefined || (Array.isArray(selected) && selected.length === 0)){
      return false;
    } else {
      return true;
    }
  }

  devolverNombreDeCerveza(cervezaId: number){
    for(let j=0; j<this.cervezasEstadisticas.length; j++){
      if(this.cervezasEstadisticas[j].value == cervezaId){
        return this.cervezasEstadisticas[j].name;
      }
    }
    return "";
  }

  filtrarComunidades(){
    let comunidadesFiltradas : Comunidades[] = [];
    //Filtrar por pais
    if(this.selectedPaises.length != 0){
      for(let i=0; i<this.comunidades.length; i++){
        for(let j=0; j<this.selectedPaises.length; j++){
          if(this.comunidades[i].pais == this.selectedPaises[j]){
            comunidadesFiltradas.push({
              name: this.comunidades[i].name,
              pais: this.comunidades[i].pais
            })
          }
        }
      }
    }
    this.comunidades = comunidadesFiltradas;
  }

  filtrarProvincias(){
    let provinciasFiltradas : Provincias[] = [];
    //Filtrar por comunidad
    if(this.selectedComunidades.length != 0 && this.selectedPaises.length == 0){
      for(let i=0; i<this.provincias.length; i++){
        for(let j=0; j<this.selectedComunidades.length; j++){
          if(this.provincias[i].comunidad == this.selectedComunidades[j]){
            provinciasFiltradas.push({
              name: this.provincias[i].name,
              comunidad: this.provincias[i].comunidad,
              pais: this.provincias[i].pais
            })
          }
        }
      }
    }
    //Filtrar por comunidad
    if(this.selectedComunidades.length == 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.provincias.length; i++){
        for(let j=0; j<this.selectedPaises.length; j++){
          if(this.provincias[i].pais == this.selectedPaises[j]){
            provinciasFiltradas.push({
              name: this.provincias[i].name,
              comunidad: this.provincias[i].comunidad,
              pais: this.provincias[i].pais
            })
          }
        }
      }
    }
    //Filtrar por pais y comunidad (Se mira solo la comunidad, ya que es el nivel más inferior)
    if(this.selectedComunidades.length != 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.provincias.length; i++){
        for(let j=0; j<this.selectedComunidades.length; j++){
          if(this.provincias[i].comunidad == this.selectedComunidades[j]){
            provinciasFiltradas.push({
              name: this.provincias[i].name,
              comunidad: this.provincias[i].comunidad,
              pais: this.provincias[i].pais
            })
          }
        }
      }
    }
    this.provincias = provinciasFiltradas;
  }

  filtrarLocalidades(){
    let localidadesFiltradas : Localidades[] = [];
    //Si está selecciona una provincia y no una comunidad y pais se filtra por provincia
    if(this.selectedProvincias.length != 0 && this.selectedComunidades.length == 0 && this.selectedPaises.length == 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let j=0; j<this.selectedProvincias.length; j++){
          if(this.localidades[i].provincia == this.selectedProvincias[j]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            })
          }
        }
      }
    }
    //Si la comunidad está selecciona y la provincia y el pais no se filtra por comunidad
    if(this.selectedProvincias.length == 0 && this.selectedComunidades.length != 0 && this.selectedPaises.length == 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let x=0; x<this.selectedComunidades.length; x++){
          if(this.localidades[i].comunidad == this.selectedComunidades[x]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            })
          }
        }
      }
    }
    //Si la comunidad y la provincia están seleccionadas y el pais no se filtra por las dos
    if(this.selectedProvincias.length != 0 && this.selectedComunidades.length != 0 && this.selectedPaises.length == 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let j=0; j<this.selectedProvincias.length; j++){
          if(this.localidades[i].provincia == this.selectedProvincias[j]){
              localidadesFiltradas.push({
                id: this.localidades[i].id,
                name: this.localidades[i].name,
                codigoPostal: this.localidades[i].codigoPostal,
                provincia: this.localidades[i].provincia,
                comunidad: this.localidades[i].comunidad,
                pais: this.localidades[i].pais
            })
          }
        }
      }
    }
    //Se filtra solo por pais
    if(this.selectedProvincias.length == 0 && this.selectedComunidades.length == 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let j=0; j<this.selectedPaises.length; j++){
          if(this.localidades[i].pais == this.selectedPaises[j]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            })
          }
        }
      }
    }
    //Se filtra solo por pais y comunidad
    if(this.selectedProvincias.length == 0 && this.selectedComunidades.length != 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let x=0; x<this.selectedComunidades.length; x++){
          if(this.localidades[i].comunidad == this.selectedComunidades[x]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            });
          }
        }
      }
    }
    //Se filtra solo por pais y provincia
    if(this.selectedProvincias.length != 0 && this.selectedComunidades.length == 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let x=0; x<this.selectedProvincias.length; x++){
          if(this.localidades[i].provincia == this.selectedProvincias[x]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            });
          }
        }
      }
    }
    //Se filtra solo por pais, provincia y comunidad
    if(this.selectedProvincias.length != 0 && this.selectedComunidades.length != 0 && this.selectedPaises.length != 0){
      for(let i=0; i<this.localidades.length; i++){
        for(let y=0; y<this.selectedProvincias.length; y++){
          if(this.localidades[i].provincia == this.selectedProvincias[y]){
            localidadesFiltradas.push({
              id: this.localidades[i].id,
              name: this.localidades[i].name,
              codigoPostal: this.localidades[i].codigoPostal,
              provincia: this.localidades[i].provincia,
              comunidad: this.localidades[i].comunidad,
              pais: this.localidades[i].pais
            });
          }
        }
      }
    }
    this.localidades = localidadesFiltradas;
  }

  isColumnDisplayed(columnName: string): boolean {
    return this.displayedColumns.includes(columnName);
  }

  obtenerDiaSiguiente(diaActual: string): string {
    const fechaObjeto = new Date(diaActual);
    const diaSiguiente = addDays(fechaObjeto, 1);
    return diaSiguiente.toISOString().slice(0, 10);
  }

  formatHour(hour:number) {
    if (hour >= 0 && hour <= 23) {
      return hour.toString().padStart(2, '0') + ":00";
    } else {
      return "Hora no válida";
    }
  }

  formatDate(data:any) {
    const { year, month, day } = data;
    const fechaFormateada = `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
    return fechaFormateada;
  }

  formatDateSemanaMesAño(data:any) {
    const { week, month, year } = data;
    const fechaFormateada = `${year}/${month.toString().padStart(2, '0')}/${week.toString().padStart(2, '0')}`;
    return fechaFormateada;
  }

  formatDateSemanaAño(data:any) {
    const { week, year } = data;
    const fechaFormateada = `${year}/${week.toString().padStart(2, '0')}`;
    return fechaFormateada;
  }

  formatDateDiaMesAño(data: any) {
    const { day, month, year } = data;
    const fechaFormateada = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    return fechaFormateada;
  }

  formatDateSemana(data:any) {
    const { year, month, week } = data;
    const fechaFormateada = `${year}/${week}`;
    return fechaFormateada;
  }

  formatDateMes(data:any) {
    const { year, month } = data;
    const fechaFormateada = `${year}/${month.toString().padStart(2, '0')}`;
    return fechaFormateada;
  }

  devolverNombreDeCervezaConIdOColumn(columna: string){
    let cervezaNumero: any;
    const isCervezaColumn = columna.startsWith('cerveza');
    const isDateColumn = columna.startsWith('date');
    if (isCervezaColumn) {
      const match = columna.match(/^cerveza(\d+)$/);
      if (match) {
        cervezaNumero = parseInt(match[1], 10);
        console.log(cervezaNumero);
        for(let i=0; i<this.cervezasEstadisticas.length; i++){
          if(this.cervezasEstadisticas[i].value == cervezaNumero){
            return this.cervezasEstadisticas[i].name;
          }
        }
      } 
      return columna;
    }
    if(isDateColumn){
      return "Fecha";
    }
    return columna;
  }

  /*downloadExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');
    //worksheet.addRow(["Filtros aplicados:", this.textoResumen]);
    console.log(this.textoResumen);
    //worksheet.addRow(["Filtros aplicados:", this.textoResumen || ""]);
    const excelColumns = this.displayedColumns.map(column => {
      console.log(column);
      const isCervezaColumn = column.startsWith('cerveza');
      const columnKey = isCervezaColumn ? 'consumosPorTipo' : column;
      return { 
        header: this.devolverNombreDeCervezaConIdOColumn(column), 
        key: columnKey, 
        width: 25
      };
    });
    worksheet.columns = excelColumns;
    worksheet.spliceRows(1, 0, []) 
    worksheet.spliceRows(1, 0, [])
    worksheet.getCell('A1').value = this.textoResumen;
    /*worksheet.columns = [
      { header: 'Establecimiento', key: 'nombreEstablecimiento', width: 20 },
      { header: 'Consumo Total', key: 'consumoTotal', width: 16 },
      // Agrega más columnas según sea necesario
    ];*/ /*
    // Agregar los datos a las filas del archivo de Excel
    this.listaEstablecimientos.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });
    // Generar el archivo de Excel en formato Buffer
    workbook.xlsx.writeBuffer().then(buffer => {
      // Crear un Blob a partir del Buffer
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // Descargar el archivo utilizando la librería FileSaver.js
      saveAs(blob, 'Listado de consumo de establecimientos DataBeer.xlsx');
    });
  }*/

  exportToExcel(): void {
    // Crear un nuevo libro de Excel y una hoja de trabajo
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('DataBeer Historicos');

    // Encabezados de columna
    this.displayedColumns.forEach((column, index) => {
      const columnName = this.devolverNombreDeCervezaConIdOColumn(column);
      worksheet.getCell(3, index + 1).value = columnName; //Las columnas empiezan en la fila 3

      //Ancho de la celda basado en el tamaño de la palabra
      worksheet.getColumn(index + 1).width = columnName.length + 2;
    });

    worksheet.getCell('A1').value = this.textoResumen;
  
    // Datos
    this.listaEstablecimientos.forEach((element, rowIndex) => {
      this.displayedColumns.forEach((column, columnIndex) => {
        const cellValue = this.getCellValue(column, element);
        const cell = worksheet.getCell(rowIndex + 4, columnIndex + 1); //Los datos se muestran a partir de la fila 4
        cell.value = cellValue;

        // Ajustar el ancho de la columna basado en el tamaño del contenido
        const columnWidth = cell.text.length + 2;

        // Obtener la referencia a la columna actual
        const currentColumn = worksheet.getColumn(columnIndex + 1);

        // Asegurarse de que la columna exista antes de intentar ajustar su ancho
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
  
    // Crear un blob con el contenido del libro de Excel
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
      // Descargar el archivo
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Listado de consumo de establecimientos DataBeer.xlsx';
      link.click();
    });
  }

  /*ExportTOExcel(){
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'SheetJS.xlsx');  
  }*/

  getUniqueBeerTypeColumns(): string[] {
    const columns: string[] = [];
    this.listaEstablecimientos.forEach(establecimiento => {
      establecimiento.consumosPorTipo.forEach((beerType:any) => {
        const columnName = `Consumo ${beerType.id}`; // Usar id en lugar de type
        if (!columns.includes(columnName)) {
          columns.push(columnName);
        }
      });
    });
    return columns;
  }

  //Obtener el consumo de la cerveza para enseñarlo en las filas
  getCellValue(column: string, element: any): any {
    if (column.startsWith('cerveza')) {
      const cervezaId = parseInt(column.replace('cerveza', ''), 10);
      //const cervezaConsumo = element.consumosPorTipo.find((cerveza: Cervezas) => cerveza.value === cervezaId);
      for(let i=0; i<element.consumosPorTipo.length; i++){
        if(cervezaId == element.consumosPorTipo[i].id){
          return element.consumosPorTipo[i].consumo
        }
      }
    } else {
      return element[column];
    }
  }

  //Ver si la columna es del tipo cerveza + cerveza.value
  isCervezaColumn(column: string): boolean {
    return this.cervezasEstadisticas.some(cerveza => this.cervezasSeleccionadas.includes(cerveza.name) && column === 'cerveza' + cerveza.value);
  }

  //SORT PERSONALIZADO
  public sortData(sort: Sort) {
    //console.log(sort);
    const data = this.listaEstablecimientos.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
  
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      
      // Agrega la condición para verificar si la columna es del tipo 'cervezaX'
      if (sort.active.startsWith('cerveza')) {
        const cervezaId = parseInt(sort.active.replace('cerveza', ''), 10);
        const getConsumo = (item: any) => {
          const consumo = item.consumosPorTipo.find((c: any) => parseFloat(c.id) === cervezaId);
          console.log(consumo);
          return consumo ? parseFloat(consumo.consumo) : 0;
        };
  
        return this.compare(getConsumo(a), getConsumo(b), isAsc);
      }
      // Si la columna no es del tipo 'cervezaX', realiza una comparación estándar
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      return this.compare(valueA, valueB, isAsc);
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  verificarDiaActualEnRangoFechas(start: string, end: string, actual: string): boolean {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const currentDate = new Date(actual);
    // Asegúrate de que las fechas sean válidas
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || isNaN(currentDate.getTime())) {
      //throw new Error('Fechas no válidas');
      this.errorMessage = "Fechas no válidas";
    }
    // Verifica si la fecha actual está dentro del rango
    return currentDate >= startDate && currentDate <= endDate;
  }

  async calcularConsumoDiaActual() {
    this.consumoDiaActual = [];
    return new Promise<void>((resolve, reject) => {
      const diaSiguiente = this.obtenerDiaSiguiente(this.fechaActualString);
      this.historicoDiaSubscription = this.deviceService.getMultiHistoricRaw(this.devicesReferences, this.fechaActualString, diaSiguiente, "0").subscribe({
        next: resp => {
          const camposTanque1 = ['field11', 'field12', 'field20'];
          const camposTanque2 = ['field13', 'field14', 'field21'];
          const camposTanque3 = ['field15', 'field16', 'field22'];
          const camposTanque4 = ['field26', 'field27', 'field28'];

          for (let i = 0; i < resp.length; i++) {
            const tanques = {
              tanque1: this.obtenerDatosTanque(resp[i], camposTanque1, 'beer_type_id_1'),
              tanque2: this.obtenerDatosTanque(resp[i], camposTanque2, 'beer_type_id_2'),
              tanque3: this.obtenerDatosTanque(resp[i], camposTanque3, 'beer_type_id_3'),
              tanque4: this.obtenerDatosTanque(resp[i], camposTanque4, 'beer_type_id_4'),
            };

            // Calcular el consumo total por tipo de cerveza
            const consumoPorTipo = [
              this.encontrarCervezaPorId(tanques.tanque1.cervezaId, tanques.tanque1.consumo),
              this.encontrarCervezaPorId(tanques.tanque2.cervezaId, tanques.tanque2.consumo),
              this.encontrarCervezaPorId(tanques.tanque3.cervezaId, tanques.tanque3.consumo),
              this.encontrarCervezaPorId(tanques.tanque4.cervezaId, tanques.tanque4.consumo),
            ].filter(cerveza => cerveza !== null);

            // Calcular el consumo total
            const consumoTotal = this.calcularConsumoTotal([tanques.tanque1.consumo, tanques.tanque2.consumo, tanques.tanque3.consumo, tanques.tanque4.consumo]);
  
            this.consumoDiaActual.push({
              dispositivoId: resp[i].id,
              //establecimientoId: resp[i].dev_est_id,
              establecimiento: this.devolverEstablecimiento(resp[i].dev_est_id),
              tanques: tanques,
              consumoTotal: consumoTotal,
              consumoPorTipo: consumoPorTipo,
            });
          }

          // Realizar la operación de reducción para sumar el consumo por tipo y eliminar las entradas null
          this.consumoDiaActual = this.consumoDiaActual.reduce((accum: any, item: any) => {
            const filteredConsumoPorTipo = Object.fromEntries(Object.entries(item.consumoPorTipo).filter(([_, v]) => v !== null));
            const existingItem = accum.find((i:any) => i.dispositivoId === item.dispositivoId);

            if (existingItem) {
              existingItem.consumoPorTipo = { ...existingItem.consumoPorTipo, ...filteredConsumoPorTipo };
            } else {
              accum.push({
                dispositivoId: item.dispositivoId,
                establecimiento: item.establecimiento,
                tanques: item.tanques,
                consumoTotal: item.consumoTotal,
                consumoPorTipo: filteredConsumoPorTipo,
              });
            }

            return accum;

          }, []);
          resolve();
        },
        error: err => {
          reject(err);
        },
        complete: () => {},
      });
    });
  }

  // Función para encontrar la cerveza por ID en la lista
  encontrarCervezaPorId(beerTypeId: number, consumo: number) {
    const cerveza = this.cervezas.find(c => c.value === beerTypeId);
    return cerveza ? { id: cerveza.value, type: cerveza.name, consumo: consumo } : null;
  }

  filtrarConsumosPorEstablecimiento(){
    let consumosPorEstabliciento: any = [];
    //let consumosPorEstablecimiento: any;
    for(let i=0; i<this.establecimientosData.length; i++){
      const establecimientoId = this.establecimientosData[i].id;

      const listaconsumosPorEstablecimiento = this.consumoDiaActual.filter((consumo: any) => {
        return consumo.establecimiento.id === establecimientoId;
      });

      const consumosPorEstablecimiento = this.consumoDiaActual
      .filter((consumo: any) => consumo.establecimiento.id === establecimientoId)
      .map((consumo: any) => consumo.consumoTotal);

      const consumoTotalEstablecimiento = consumosPorEstablecimiento.reduce((acc: number, consumo: number) => acc + consumo, 0);
      
      const consumosPorTipoDeCerveza: any = [];
      for(let i=0; i<listaconsumosPorEstablecimiento.length; i++){
        for (const consumoActual of Object.values(listaconsumosPorEstablecimiento[i].consumoPorTipo)) {
          //const consumoActual = listaconsumosPorEstablecimiento[i].consumoPorTipo[j];
          const index = consumosPorTipoDeCerveza.findIndex((consumo: any) => consumo.id === (consumoActual as any).id);
          if (index !== -1) {
            // Si la cerveza ya está presente, sumar el consumo
            consumosPorTipoDeCerveza[index].consume += (consumoActual as any).consumo;
          } else {
            // Si la cerveza no está presente, añadirla a la lista
            consumosPorTipoDeCerveza.push({ id: (consumoActual as any).id, type: (consumoActual as any).type, consume: (consumoActual as any).consumo });
          }
        }
      }

      // Añadir las cervezas que no están en la lista con consumo 0
      for (let i = 0; i < this.cervezas.length; i++) {
        const cervezaActual = this.cervezas[i];
        // Verificar si la cerveza está presente en consumosPorTipoDeCerveza
        const cervezaEnLista = consumosPorTipoDeCerveza.find((item:any) => item.id === cervezaActual.value);
        if (!cervezaEnLista) {
          // Si la cerveza no está en la lista, añadirla con consumo = 0
          consumosPorTipoDeCerveza.push({ id: cervezaActual.value, type: cervezaActual.name, consume: 0 });
        }
      }

      consumosPorEstabliciento.push({
        establecimiento: this.establecimientosData[i],
        establecimientoNombre: this.establecimientosData[i].est_name,
        //establecimientoId: this.establecimientosData[i].id,
        cervezas: consumosPorTipoDeCerveza,
        consumos: listaconsumosPorEstablecimiento,
        consumoTotal: consumoTotalEstablecimiento
      });
    }
    return consumosPorEstabliciento;
  }

  calcularConsumoTotal(consumos: number[]): number {
    return parseFloat((consumos.reduce((total, consumo) => total + consumo, 0)).toFixed(2));
  }

  obtenerDatosTanque(respItem: any, camposTanque: string[], cervezaProp: string) {
    const datosPorHora: { [hora: string]: { [tipoCerveza: string]: number } } = {};

    respItem.readers_raw.forEach((lectura: any) => {
      const cervezaId = lectura[cervezaProp] || null;
      const consumo = this.calcularConsumoTanque([lectura], camposTanque);
      const hora = lectura.created_at ? new Date(lectura.created_at).toISOString().slice(0, 13) : null;
  
      if (hora !== null && cervezaId !== null) {
        if (!datosPorHora[hora]) {
          datosPorHora[hora] = {};
        }
        if (!datosPorHora[hora][cervezaId]) {
          datosPorHora[hora][cervezaId] = 0;
        }
        datosPorHora[hora][cervezaId] += consumo;
      }
    });

    const consumosPorHora: { hora: string, tipoCerveza: string, consumo: number }[] = [];
    Object.keys(datosPorHora).forEach(hora => {
      Object.keys(datosPorHora[hora]).forEach(tipoCerveza => {
        const consumoPorTipoCerveza = datosPorHora[hora][tipoCerveza];
        consumosPorHora.push({
          hora: hora,
          tipoCerveza: tipoCerveza,
          consumo: consumoPorTipoCerveza,
        });
      });
    });

    return {
      cervezaId: respItem.readers_raw[0]?.[cervezaProp] || null,
      consumo: this.calcularConsumoTanque(respItem.readers_raw, camposTanque),
      //consumoPorHora: consumosPorHora,
    };
  }
  
  calcularConsumoTanque(readersRaw: any[], campos: string[]): number {
    let consumoTanque = 0;
    readersRaw.forEach(reader => {
      campos.forEach(campo => {
        if (reader && reader[campo] !== undefined) {
          consumoTanque += parseFloat(reader[campo] !== null ? reader[campo] : 0);
        } else {
          consumoTanque += 0;
        }
      });
    });
    return parseFloat(consumoTanque.toFixed(2));
  }

  async ejecutarFiltros() {
    this.sinDatos = false;
    this.todosIguales = false;
    this.primerNombreEstablecimiento = "";
    this.cargarDatos = undefined;
    this.listaEstablecimientos = [];
    //Borrar las columnas
    this.displayedColumns = []
    //let listaEstablecimientos: EstablecimientoData[] = [];
    this.errorMessage = "";
    this.mostrarTabla = false;
    this.mostrarTabla1 = false;
    //FECHA
    this.startGlobal = this.convertirFechaInicio(this.selectedDateGlobal);
    this.endGlobal = this.convertirFechaFin(this.selectedDateGlobal);

    //console.log("La fecha seleccionada de inicio en global es: ",this.startGlobal);
    //console.log("La fecha seleccionada de fin en global es: ",this.endGlobal);
    //console.log("La fecha actual es: ",this.fechaActualString);
    //console.log("La fecha seleccionada de inicio en global es: ", this.startGlobal);
    //console.log("La fecha seleccionada de fin en global es: ", this.endGlobal);
    //console.log("Intervalo fecha: ", this.opcionSeleccionada);

    //UBICACIÓN
    //console.log("Países elegidos: ", this.selectedPaises);

    //Si las comunidades seleccionadas no están dentro de las comunidades mostradas no se enseñan
    const comunidadesSeleccionadas = this.comunidades.filter(comunidad => {
      return this.selectedComunidades.includes(comunidad.name);
    });
    this.selectedComunidades = comunidadesSeleccionadas.map(comunidad => comunidad.name);
    //console.log("Comunidades elegidas: ", this.selectedComunidades);

    //Si las provincias seleccionadas no están dentro de las provincias mostradas no se enseñan
    const provinciasSeleccionadas = this.provincias.filter(provincia => {
      return this.selectedProvincias.includes(provincia.name);
    });
    this.selectedProvincias = provinciasSeleccionadas.map(provincia => provincia.name);
    //console.log("Provincias elegidas: ", this.selectedProvincias);

    //Si las localidades seleccionadas no están dentro de las localidades mostradas no se enseñan
    const localidadesSeleccionadas = this.localidades.filter(localidad => {
      return this.selectedLocalidades.includes(localidad.id);
    });
    this.selectedLocalidades = localidadesSeleccionadas.map(localidad => localidad.id);
    //console.log("Localidades elegidas: ", this.selectedLocalidades);

    //ESTABLECIMIENTO

    //Si el establecimiento no está acutualmente en la lista de establecimientos filtrados no se cogen
    if (Array.isArray(this.selectedEstablecimiento)) {
      this.selectedEstablecimiento = this.selectedEstablecimiento.filter(seleccionado => {
        for (let i = 0; i < this.establecimientosCopia.length; i++) {
          if (this.establecimientosCopia[i].value === seleccionado) {
            return true;
          }
        }
        return false;
      }) as number[];
    }
    //console.log("Establecimiento elegido: ", this.selectedEstablecimiento);

    //TIPO DE CERVEZA
    //console.log('Tipos de cerveza seleccionados:', this.selectedCervezas);

    //DELEGACION
    //console.log("Delegación elegida: ", this.selectedDelegacion);

    //Devolver las referencias de los dispositivos
    /*let references: string[] = [];
    if (Array.isArray(this.selectedEstablecimiento)) {
      for(let i=0; i<this.selectedEstablecimiento.length; i++){
        for( let j=0; j<this.establecimientosData.length; j++){
          if(this.selectedEstablecimiento[i] == this.establecimientosData[j].id){
            for(let x=0; x<this.establecimientosData[j].devices.length; x++){
              references.push(this.establecimientosData[j].devices[x].dev_reference);
            }
          }
        }
      }
      this.devicesReferences = references.join('-');
      console.log(this.devicesReferences);
    }*/

    //VERIFICAR QUE EL DIA ACTUAL ESTÁ EN EL RANGO DE FECHAS
    /*const fechaActualPresente = this.verificarDiaActualEnRangoFechas(this.startGlobal, this.endGlobal, this.fechaActualString);
    let consumoPorEstablecimiento: any = [];
    console.log(fechaActualPresente);
    if(fechaActualPresente){
      await this.calcularConsumoDiaActual();
      console.log("RESPUESTA RESULTADO CONSUMOS: ",this.consumoDiaActual);
      consumoPorEstablecimiento = this.filtrarConsumosPorEstablecimiento();
    }*/

    //console.log(this.selectedEstablecimiento);

    if(this.errorMessage == ""){
      //OPCIONES DE LA CONSULTA
      const establecimientoData = new FormData();
      establecimientoData.append('start', this.startGlobal);
      establecimientoData.append('end', this.obtenerDiaSiguiente(this.endGlobal));
      /*if(this.selectedEstablecimiento.length != 0){
        establecimientoData.append('establecimientos', JSON.stringify(this.selectedEstablecimiento));
      }*/
      if(this.selectedEstablecimiento.length != 0){
        establecimientoData.append('establecimientos', JSON.stringify(this.selectedEstablecimiento));
      }
      if(this.selectedLocalidades.length != 0){
        establecimientoData.append('localidades', JSON.stringify(this.selectedLocalidades));
      }
      if(this.selectedProvincias.length != 0){
        establecimientoData.append('provincias', JSON.stringify(this.selectedProvincias));
      }
      if(this.selectedComunidades.length != 0){
        establecimientoData.append('comunidades', JSON.stringify(this.selectedComunidades));
      }
      if(this.selectedPaises.length != 0){
        establecimientoData.append('paises', JSON.stringify(this.selectedPaises));
      }
      if(this.opcionSeleccionada=="porTotal"){
        this.intervalosFecha = "consumo total ";
        establecimientoData.append('desglose', "total");
      }
      if(this.opcionSeleccionada=="porHoras"){
        this.intervalosFecha = "consumo por horas "
        establecimientoData.append('desglose', "hours");
      }
      if(this.opcionSeleccionada=="porDia"){
        this.intervalosFecha = "consumo por días "
        establecimientoData.append('desglose', "days");
      }
      if(this.opcionSeleccionada=="porSemana"){
        this.intervalosFecha = "consumo por semanas "
        establecimientoData.append('desglose', "weeks");
      }
      if(this.opcionSeleccionada=="porMes"){
        this.intervalosFecha = "consumo por meses "
        establecimientoData.append('desglose', "months");
      }

      /*console.log("ESTABLECIMIENTOS DE FORMDATA",JSON.stringify(this.selectedEstablecimiento));
      console.log("LOCALIDADES DE FORMDATA",JSON.stringify(this.selectedLocalidades));
      console.log("PROVINCIAS DE FORMDATA",JSON.stringify(this.selectedProvincias));
      console.log("COMUNIDADES DE FORMDATA",JSON.stringify(this.selectedComunidades));
      console.log("PAISES DE FORMDATA",JSON.stringify(this.selectedPaises));*/

      this.resultadoSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
        next: resp =>{
          console.log("RESPUESTA: ",resp);
          if(resp.error){
            this.errorMessage = resp.error;
          } else {
            for(let i=0; i<resp.length; i++){
              let consumoTotal = 0.00;
              const consumosPorTipo: { [key: number]: { name: string, consumo: number } } = {};
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    const name = beerType.type;
                    const id = beerType.id;
                    const consumo = beerType.consume;
                    consumoTotal += beerType.consume;
                    // Almacena el consumo y el ID de la cerveza en consumosPorTipo
                    consumosPorTipo[id] = {
                      name: name,
                      consumo: consumo,
                    };
                  }
                }
              }
              const consumoTotalRedondeado = consumoTotal.toFixed(2);
              // Crear un objeto para almacenar los consumos por tipo en el formato deseado
              const consumosPorTipoArray = Object.keys(consumosPorTipo).map((id:any) => ({
                id,
                name: consumosPorTipo[id].name,
                consumo: (consumosPorTipo[id].consumo),
              }));
              if(this.opcionSeleccionada=="porMes"){
                const data = {
                  year: resp[i].year,
                  month: resp[i].month,
                };
                const establecimientoData: any = {
                  nombreEstablecimiento: resp[i].name,
                  consumoTotal: (parseFloat(consumoTotalRedondeado)),
                  consumosPorTipo: consumosPorTipoArray,
                  porHoras: this.formatHour(resp[i].hour),
                  date1: "",
                  date2: "",
                  date3: this.formatDateMes(data),
                  day: 0,
                  week: resp[i].week,
                  month: resp[i].month,
                  year: resp[i].year
                };
                this.listaEstablecimientos.push(establecimientoData);
              }
              if(this.opcionSeleccionada=="porSemana"){
                const data = {
                  year: resp[i].year,
                  month: resp[i].month,
                  week: resp[i].week,
                };
                const establecimientoData: any = {
                  nombreEstablecimiento: resp[i].name,
                  consumoTotal: (parseFloat(consumoTotalRedondeado)),
                  consumosPorTipo: consumosPorTipoArray,
                  porHoras: this.formatHour(resp[i].hour),
                  date1: "",
                  date2: this.formatDateSemana(data),
                  date3: "",
                  day: 0,
                  week: resp[i].week,
                  month: resp[i].month,
                  year: resp[i].year
                };
                this.listaEstablecimientos.push(establecimientoData);
              }
              if(this.opcionSeleccionada=="porDia"){
                const data = {
                  year: resp[i].year,
                  month: resp[i].month,
                  day: resp[i].day,
                };
                const establecimientoData: any = {
                  nombreEstablecimiento: resp[i].name,
                  consumoTotal: (parseFloat(consumoTotalRedondeado)),
                  consumosPorTipo: consumosPorTipoArray,
                  porHoras: this.formatHour(resp[i].hour),
                  date1: this.formatDate(data),
                  date2: "",
                  date3: "",
                  day: resp[i].day,
                  week: resp[i].week,
                  month: resp[i].month,
                  year: resp[i].year
                };
                this.listaEstablecimientos.push(establecimientoData);
              }
              if(this.opcionSeleccionada=="porHoras"){
                const data = {
                  day: resp[i].day,
                  month: resp[i].month,
                  year: resp[i].year
                };
                const establecimientoData: any = {
                  nombreEstablecimiento: resp[i].name,
                  consumoTotal: (parseFloat(consumoTotalRedondeado)),
                  consumosPorTipo: consumosPorTipoArray,
                  porHoras: this.formatHour(resp[i].hour),
                  date1: this.formatDate(data),
                  date2: "",
                  date3: "",
                  day: resp[i].day,
                  week: resp[i].week,
                  month: resp[i].month,
                  year: resp[i].year
                };
                this.listaEstablecimientos.push(establecimientoData);
              }
              if(this.opcionSeleccionada=="porTotal"){
                const establecimientoData: any = {
                  nombreEstablecimiento: resp[i].name,
                  consumoTotal: (parseFloat(consumoTotalRedondeado)),
                  consumosPorTipo: consumosPorTipoArray,
                  porHoras: "",
                  date1: "",
                  date2: "",
                  date3: "",
                  day: 0,
                  week: 0,
                  month: 0,
                  year: 0
                };
                this.listaEstablecimientos.push(establecimientoData);
              }
            }
            this.mostrarTabla1 = true;
            this.dataSource = new MatTableDataSource(this.listaEstablecimientos);
            this.cargarDatos = true;
            this.numeroFilas = this.listaEstablecimientos.length;
            if(Math.floor(this.numeroFilas/2)==0){
              this.pageSizeOptions = [this.numeroFilas];
            } else {
              this.pageSizeOptions = [10, 25, 50, 100];
            }
            console.log("LISTA ESTABLECIMIENTOS: ",this.listaEstablecimientos);
            setTimeout(() => {
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
              //Sort personalizado
              /*const sortState: Sort = {
                active: 'releaseDate', 
                direction: 'desc'
              };
              this.sort.active = sortState.active;
              this.sort.direction = sortState.direction;
              this.sort.sortChange.emit(sortState);*/
            },0);
          }
        }, error:err =>{
          console.log(err);
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          if (this.listaEstablecimientos.length > 0) {
            this.comprobarTodosLosEstablecimientosIguales();
          } /*else {
            // Utilizar la llamada raw cuando no hay respuesta del servidor pero está el día actual en la peticion 
            if(fechaActualPresente){
              if(this.selectedEstablecimiento.length == 0 && !this.ubicacionSeleccionadaBoolean()){
                this.errorMessage = "No hay filtros selccionados";
              } else {
                // Eliminamos el mensaje del servidor de que no hay respuesta
                this.errorMessage = "";
                if(this.opcionSeleccionada=="porTotal"){
                  // Caso en el que seleccionemos algún establecimiento
                  if(this.selectedEstablecimiento.length > 0){
                    for(let i=0; i<consumoPorEstablecimiento.length; i++){
                      if (this.selectedEstablecimiento.includes(consumoPorEstablecimiento[i].establecimiento.id)) {
                        // Solo añadimos el establecimiento si su consumoTotal es mayor a 0 y su ha sido elegido
                        if(consumoPorEstablecimiento[i].consumoTotal !== 0){
                          const establecimientoData: any = {
                            nombreEstablecimiento: consumoPorEstablecimiento[i].establecimiento.est_name,
                            consumoTotal: consumoPorEstablecimiento[i].consumoTotal,
                            consumosPorTipo: consumoPorEstablecimiento[i].cervezas,
                            porHoras: "",
                            date1: "",
                            date2: "",
                            date3: "",
                            day: 0,
                            week: 0,
                            month: 0,
                            year: 0
                          };
                          this.listaEstablecimientos.push(establecimientoData);
                        }
                      }
                    }                    
                  }
                  // Caso en que haya una ubicación seleccionada y ningún establecimiento
                  if(this.ubicacionSeleccionadaBoolean() && this.selectedEstablecimiento.length === 0){
                    console.log(this.selectedPaises);
                    for(let i=0; i<consumoPorEstablecimiento.length; i++){
                      if (this.selectedPaises.includes(consumoPorEstablecimiento[i].establecimiento.localidad.country)) {
                        // Solo añadimos el establecimiento si su consumoTotal es mayor a 0 y su ha sido elegido
                        if(consumoPorEstablecimiento[i].consumoTotal !== 0){
                          const establecimientoData: any = {
                            nombreEstablecimiento: consumoPorEstablecimiento[i].establecimiento.est_name,
                            consumoTotal: consumoPorEstablecimiento[i].consumoTotal,
                            consumosPorTipo: consumoPorEstablecimiento[i].cervezas,
                            porHoras: "",
                            date1: "",
                            date2: "",
                            date3: "",
                            day: 0,
                            week: 0,
                            month: 0,
                            year: 0
                          };
                          this.listaEstablecimientos.push(establecimientoData);
                        }
                      }
                    }                    
                  }
                  console.log(consumoPorEstablecimiento);
                }
                if(this.opcionSeleccionada=="porHoras"){

                }
                if(this.opcionSeleccionada=="porDia"){

                }
                if(this.opcionSeleccionada=="porSemana"){

                }
                if(this.opcionSeleccionada=="porMes"){

                }
              }
              // Si la lista sigue estando vacía es que no se ha podido introducir ningún dato
              if(this.listaEstablecimientos.length === 0){
                console.log("La lista de establecimientos está vacía.");
                this.sinDatos = true; 
              } else {
                this.comprobarTodosLosEstablecimientosIguales();
              }
            } else {
              console.log("La lista de establecimientos está vacía.");
              this.sinDatos = true; 
            }
          }*/
          //INTERVALOS DE TIEMPO
          if(this.opcionSeleccionada=="porHoras"){
            this.displayedColumns.push("porHoras");
            this.displayedColumns.push("date1");
          }
          if(this.opcionSeleccionada=="porDia"){
            this.displayedColumns.push("date1");
          }
          if(this.opcionSeleccionada=="porSemana"){
            this.displayedColumns.push("date2");
          }
          if(this.opcionSeleccionada=="porMes"){
            this.displayedColumns.push("date3");
          }
          this.cervezasSeleccionadas = this.selectedCervezas.map(id => {
            const cerveza = this.cervezasEstadisticas.find(item => item.value === id);
            return cerveza ? { name: cerveza.name, value: cerveza.value } : { name: '', value: '' };
          });
          //console.log("CERVEZAS SELECCIONADAS: ",this.cervezasSeleccionadas);
          //console.log("CERVEZAS: ", this.cervezasEstadisticas);
          //COLUMNAS DE TIPO DE CERVEZA
          for (const cerveza of this.cervezasSeleccionadas) {
            const columna = 'cerveza' + cerveza.value;
            if (!this.displayedColumns.includes(columna)) {
              this.displayedColumns.push(columna);
            }
          }

          /*
          for(let i=0; i<this.selectedCervezas.length; i++){
            if(this.selectedCervezas[i]==1){
              this.displayedColumns.push("estrellaGaliciaEspecial");
            }
            if(this.selectedCervezas[i]==2){
              this.displayedColumns.push("estrellaGalicia1906");
            }
            if(this.selectedCervezas[i]==3){
              this.displayedColumns.push("alouminha");
            }
          }*/
          //LA COLUMNA DE CONSUMO ESTÁ SIEMPRE
          this.displayedColumns.push("consumoTotal");
          //console.log("DISPLAYED COLUMNS: ", this.displayedColumns);
          //TEXTO RESUMEN CON LOS FILTROS SELECCIONADOS
          const elementoHtml = document.createElement('div');
          elementoHtml.innerHTML = 
          `<p class="info-text">A continuación se muestra el <b class="negrita-text">${this.intervalosFecha}</b> desde el: 
              <b class="negrita-text">${this.startGlobal}</b> hasta el: <b class="negrita-text">${this.endGlobal}</b>
              ${this.existeSelected(this.selectedEstablecimiento) ? `
                ${!this.todosIguales ? ` por<b class="negrita-text"> establecimientos</b>` : ` en el establecimiento<b class="negrita-text"> ${this.primerNombreEstablecimiento}</b>`}
              ` : ''}
              ${!this.existeSelected(this.selectedEstablecimiento) && this.selectedLocalidades.length !== 0 ? `
                ${!this.todosIguales ? ` por<b class="negrita-text"> localidades</b>` : ` en la localidad de<b class="negrita-text"> ${this.primerNombreEstablecimiento}</b>`}
              ` : ''}
              ${!this.existeSelected(this.selectedEstablecimiento) && this.selectedLocalidades.length === 0 && this.existeSelected2(this.selectedProvincias) ? `
                ${!this.todosIguales ? ` por<b class="negrita-text"> provincias</b>` : ` en la provincia de<b class="negrita-text"> ${this.primerNombreEstablecimiento}</b>`}
              ` : ''}
              ${!this.existeSelected(this.selectedEstablecimiento) && this.selectedLocalidades.length === 0 && !this.existeSelected2(this.selectedProvincias) && this.existeSelected2(this.selectedComunidades) ? `
                ${!this.todosIguales ? ` por<b class="negrita-text"> comunidades autónomas</b>` : ` en la comunidad autónoma de<b class="negrita-text"> ${this.primerNombreEstablecimiento}</b>`}
              ` : ''}
              ${!this.existeSelected(this.selectedEstablecimiento) && this.selectedLocalidades.length === 0 && !this.existeSelected2(this.selectedProvincias) && !this.existeSelected2(this.selectedComunidades) && this.existeSelected2(this.selectedPaises) ? `
                ${!this.todosIguales ? ` por<b class="negrita-text"> paises</b>` : ` en el país<b class="negrita-text"> ${this.primerNombreEstablecimiento}</b>`}
              ` : ''}
              ${this.existeSelected(this.selectedCervezas) ? `
                y por tipo de cerveza: --
                ${this.selectedCervezas.map(cerveza => ` <b class="negrita-text"> ${this.devolverNombreDeCerveza(cerveza)}</b> --`).join('')}
              ` : ''}
            </p>`;
          // Extraer solo el texto sin etiquetas HTML y sin espacios en blanco o saltos de linea
          this.textoResumen = elementoHtml.textContent?.trim().replace(/\n/g, ' ').replace(/\s+/g, ' ');
        }
      });

      this.mostrarTabla = true;

      console.log("---------------------------");
    }
  }

  devolverConsumoPorPais(){

  }

  ubicacionSeleccionadaBoolean():boolean{
    if(this.selectedLocalidades.length == 0  && this.selectedProvincias.length == 0
      && this.selectedComunidades.length == 0 && this.selectedPaises.length == 0){
        return false;
    }
    return true;
  }

  // Si todos son iguales no es necesario incluirlos en la lista
  comprobarTodosLosEstablecimientosIguales(){
    this.primerNombreEstablecimiento = this.listaEstablecimientos[0].nombreEstablecimiento;
    this.todosIguales = this.listaEstablecimientos.every(establecimiento => {
      return establecimiento.nombreEstablecimiento === this.primerNombreEstablecimiento;
    });
    if (this.todosIguales) {
      //console.log("Todos los nombreEstablecimiento son iguales en todas las filas.");
    } else {
      //console.log("Los nombreEstablecimiento no son iguales en todas las filas.");
      this.displayedColumns.push("nombreEstablecimiento");
    }
  }

  /*ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      if (property.startsWith('cerveza')) {
        // Aquí manejas la lógica específica para las columnas de cerveza
        const cervezaId = parseInt(property.replace('cerveza', ''));
        const cervezaConsumo = item.consumosPorTipo.find((cerveza: any) => cerveza.value === cervezaId);
        return cervezaConsumo ? parseFloat(cervezaConsumo.consumo) : 0;
      } else {
        // Aquí manejas la lógica para otras columnas
        switch (property) {
          case 'date': {
            return new Date(item.date);
          }
          default: {
            return item[property];
          }
        }
      }
    };
  }*/

}
